import React, { Component } from "react";
import { connect } from "react-redux";
import { Chart } from "primereact/chart";
import { Text } from "react-internationalization";
import $ from "jquery";
import Header from "./Header";
//import HeaderContainer from "./Header/HeaderContainer";
import AutoComplete1 from "../Utils/GenericUI/Select";
import AutoComplete2 from "./../Utils/Select";
import ConfPdf from "./Pdfs/ConfPdf";
import { pdf } from "@react-pdf/renderer";
import { saveAs } from "file-saver";
import { KEY_PERFORMANCE_BY_CAMPAIGN as headerCampaign } from "../Utils/StaticData/DashboardHeader";
// import MenuIcon from "@material-ui/icons/Menu";
import ChevronRightSharpIcon from "@material-ui/icons/ChevronRightSharp";
import Prospectdashboard from "./prospectManagement/Prospectdashboard";
import CampaignMgmt from "./campaignMgmt/CampaignMgmt";
// import Popup from "reactjs-popup";
import { CSVLink } from "react-csv";
import DataTable from "../Utils/GenericUI/DataTable";
import {
  DataValidation,
  ILS_CONSTS,
  NEBRASKA_CONSTS,
  VERDA_CONSTS,
} from "../Utils/StaticData/Constant";
import {
  DASHBOARD_HEADER as header,
  DASHBOARD_HEADER1 as header1,
} from "../Utils/StaticData/DashboardHeader";
import {
  DASHBOARD_HEADER_PDF as pdfheader,
  DASHBOARD_HEADER_PDF1 as pdfheader1,
} from "../Utils/StaticData/DashboardHeader";
import {
  VERDA_DASHBOARD_HEADER_PDF as verdapdfheader,
  VERDA_DASHBOARD_HEADER_PDF1 as verdapdfheader1,
} from "../Utils/StaticData/DashboardHeader";
import { Styles } from "../assests/styles/DashboradStyles";
import SideBarDashboard from "./SideBarDashboard";
import PerformanceByAgent from "./KeyPerformance/PerformanceByAgent";
import PerformanceByCampaign from "./KeyPerformance/PerformanceByCampaign";
import RapidDisEnrollment from "./KeyPerformance/RapidDisEnrollment";
import AgentModal from "./KeyPerformance/AgentModal";
import { getContrastRatio, withStyles } from "@material-ui/core/styles";
import history from "../Utils/History";
import { INITIAL_STATE } from "./initialState";
import Snackbar from "@material-ui/core/Snackbar";
import Alert from "@material-ui/lab/Alert";
import OpenWithSharpIcon from "@material-ui/icons/OpenWithSharp";
import CompareArrowsIcon from "@material-ui/icons/CompareArrows";
import Modal from "react-bootstrap/Modal";
// import ModalSearch from './KeyPerformance/ModalSearch'
import SoaDocument from "./soapdf/SoaDocument";
import FooterContainer from "./Footer/FooterContainer";
import Calendar from "../components/Calendar/Calendar";
import UserManagement from "./UserManagement/UserManagement.jsx";
import {
  agentStatusDashboard,
  RapidDisEnrollmentByMonth,
  setStateParams,
  setLoginStateParams,
  setEnrollRedirect,
  planSelectionContinue,
  yearSelection,
  prospectManagement,
  campaignManagement,
  searchProspect,
  agentCategoryDashboard,
  setTokenTORedux,
  keyPerformanceByAgent,
  setKeyPerformanceByAgent,
  keyPerformanceByCampaign,
  setKeyPerformanceByCampaign,
  submittedChart,
  getMembershipAgentList,
  getZipCodes,
  getPlans,
  setPageName,
  getAgencyId,
  setLoginStateValues,
  setCampaignProspectStateParams,
  downloadFormsPdf,
} from "../Redux/Actions/webAppActions";
import { calenderTabActive } from "../Redux/Actions/ExportActions";
import Unauthorized from "../Themes/Unauthorized";
import {
  getAgentPerformanceExport,
  getCampaignPerformanceExport,
} from "../Redux/Actions/ExportActions";
import { handleDateChange } from "../Utils/DateFormatter";
import * as DateUtil from "../Utils/DatePicker";
import BulkUpload from "./BulkUpload/BulkUpload";
import { getKeyCloakToken } from "../Redux/Actions/keyCloakAction";
import * as ChartJs from "chart.js";
import DashboardServices from "./DashboardServices";
const status = [
  {
    label: "CANCELLED",
    value: "Cancelled",
  },
  {
    label: "COMPLETED ",
    value: "completed ",
  },
  {
    label: "APPROVED  ",
    value: "approved  ",
  },
  {
    label: "DENIEDELG",
    value: "Denied eligibillity",
  },
  {
    label: "DENIEDETYP",
    value: "Denied eligibillity",
  },
  {
    label: "DUPLAPPL",
    value: "Duplicate application",
  },
  {
    label: "ELGWARNING",
    value: "Eligibility review",
  },
  {
    label: "ERRORCRITL",
    value: "Eligibility review",
  },
  {
    label: "INCOMPLETE",
    value: "Incomplete",
  },
  {
    label: "INCRFIELCT",
    value: "RFI",
  },
  {
    label: "INCRFIELCT",
    value: "RFI",
  },
  {
    label: "INCRFIREQ",
    value: "RFI",
  },
  {
    label: "READYAPPR",
    value: "Being Submitted to CMS",
  },
];
class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      scrollCount: 0,
      pdfclicked: false,
      soapdfclicked: false,
      preenrollpdfclicked: false,
      cordinationpdfclicked: false,
      applicationStatusData: { statusLabels: [], statusValues: [] },
      applicationCategoryData: { categoryLabels: [], categoryValues: [] },
      pieChartStatusData: this.props.chartStatusData,
      pieChartCategoryData: this.props.chartCategoryData,
      //m360 states
      label: "",
      rowsPerPage: 10,
      selectedRowIndex: 0,
      index: 0,
      tableData: [],
      openPopup: false,
      collapse: false,
      resetFlag: false,
      displayStatusPieChart: false,
      sideBarState: false,
      prospectState: false,
      campaignState: false,
      dashboardState: false,
      bulkUploadProspect: false,
      bulkUploadCampaign: false,
      dropDownOptions: [],
      M360Status: status,
      prospectStatusLabels: ["Open", "Hold", "Closed"],
      searchFlag: false,
      snackBarOpen: false,
      searchappl: false,
      vertical: "bottom",
      horizontal: "center",
      snackBarSeverty: "",
      snackBarMsg: "",
      anchorEl: null,
      PerformanceByAgent: false,
      PerformanceByCampaign: false,
      expand: true,
      tableExpand: true,
      showRightIcon: true,
      showTable: false,
      showChart: false,
      showStatusChart: false,
      startDate: "",
      startDateRapid: "",
      endDateRapid: "",
      endDate: "",
      startDateCov: "",
      endDateCov: "",
      csvData: this.props.keyPerformanceByCampaignExport,
      memberHeader: false,
      agentName: "",
      agentSummaryKey: 0,
      campaignName: [],
      allEmails: [],
      firstName: "",
      lastName: "",
      applId: "",
      newCategoryData: {},
      newCategoryOptions: {},
      newStatusData: {},
      newStatusOptions: {},
      eventCalState: false,
      searchUserState: false,
      isAgencyAdmin: false,
      agencyErrorFlag:false,
    };
    this.searchPanelData = {};
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevState?.scrollCount != this.state.scrollCount) {
      let set = document.getElementsByClassName("scrollfix");
      for (let i = 0; i < set.length; i++) {
        set[i].blur();
        $(set[i]).datepicker && $(set[i]).datepicker("hide");
      }
    }
    if (prevProps.chartCategoryData != this.props.chartCategoryData) {
      this.setState({
        pieChartCategoryData: this.props.chartCategoryData,
      });
      this.setData(
        this.props.chartCategoryData ?? {},
        "applicationCategoryData",
        "categoryLabels",
        "categoryValues",
        "Category"
      );
    }
    if (prevProps.chartStatusData != this.props.chartStatusData) {
      this.setState({
        pieChartStatusData: this.props.chartStatusData,
      });
      this.setData(
        this.props.chartStatusData ?? {},
        "applicationStatusData",
        "statusLabels",
        "statusValues",
        "Status"
      );
    }
    if (
      prevState.applicationCategoryData !== this.state.applicationCategoryData
    ) {
      this.setState({
        newCategoryData: {
          labels: this.state.applicationCategoryData?.categoryLabels ?? [],
          datasets: [
            {
              data: this.state.applicationCategoryData?.categoryValues ?? [],
              backgroundColor: ["#fe6161", "#0ad4af", "#b91d47"],
              // hoverBackgroundColor: [
              //   "#b9edc4",
              //   "#abede2",
              //   "#5a8f86",
              //   "#56609c",
              //   "#529651",
              //   "#a68465",
              //   "#996077",
              //   "#609099",
              // ],
            },
          ],
        },
        newCategoryOptions: {
          responsive: true,
          maintainAspectRatio: true,
          aspectRatio: 2,
          title: {
            display: false,
            text: "Agent by Product Type",
            is3D: true,
          },
          plugins: {
            datalabels: {
              display: true,
              backgroundColor: "transparent",
              borderRadius: 3,
              color: "#fff",
              font: {
                size: 12,
                weight: "bold",
              },
            },
          },
          layout: {
            padding: {
              top: 15,
              right: 0,
              bottom: 0,
              left: 0,
            },
          },
          tooltips: {
            callbacks: {
              label: (tooltipItem, data1) =>
                this.getTooltip(tooltipItem, data1),
            },
          },
          onClick: this.categoryClicked,
          animation: false,
        },
        newCategoryOptionsM: {
          responsive: true,
          maintainAspectRatio: true,
          aspectRatio: 1,
          title: {
            display: false,
            text: "Agent by Product Type",
            is3D: true,
          },
          plugins: {
            datalabels: {
              display: true,
              backgroundColor: "transparent",
              borderRadius: 3,
              color: "#fff",
              font: {
                size: 12,
                weight: "bold",
              },
            },
          },
          layout: {
            padding: {
              top: 15,
              right: 0,
              bottom: 0,
              left: 0,
            },
          },
          tooltips: {
            callbacks: {
              label: (tooltipItem, data1) =>
                this.getTooltip(tooltipItem, data1),
            },
          },
          onClick: this.categoryClicked,
          animation: false,
        },
      });
    }

    if (prevState.applicationStatusData !== this.state.applicationStatusData) {
      let getTotal = function (myDoughnutChart) {
        let sum = myDoughnutChart.config.data.datasets[0].data.reduce(
          (a, b) => a + b,
          0
        );
        return `${sum}`;
      };
      this.setState({
        newStatusData: {
          labels: this.state.applicationStatusData?.statusLabels ?? [],
          datasets: [
            {
              data: this.state.applicationStatusData?.statusValues ?? [],
              backgroundColor: [
                "#00aba9",
                "#fe6161",
                "#b91d47",
                "#63b0a3",
                "#5a8f86",
                "#56609c",
                "#529651",
                "#a68465",
                "#996077",
                "#609099",
                "#fcba03",
                "#abeb0c",
              ],
              // hoverBackgroundColor: [
              //   "#b9edc4",
              //   "#abede2",
              //   "#5a8f86",
              //   "#56609c",
              //   "#529651",
              //   "#a68465",
              //   "#996077",
              //   "#609099",
              // ],
            },
          ],
        },
        newStatusOptions: {
          responsive: true,
          maintainAspectRatio: true,
          aspectRatio: 2,
          tooltips: {
            callbacks: {
              label: (tooltipItem, data1) =>
                this.getTooltip(tooltipItem, data1),
            },
          },
          plugins: {
            datalabels: {
              display: true,
              backgroundColor: "transparent",
              borderRadius: 3,
              color: "#fff",
              font: {
                size: 12,
                weight: "bold",
              },
            },
            legend: {
              display: true,
              position: "left",
              // align:"start",
              animation: false,
              labels: {
                fontSize: 15,
              },
            },
            doughnutlabel: {
              labels: [
                {
                  text: "Total",
                  font: {
                    size: "12",
                  },
                  color: "grey",
                },
                {
                  text: getTotal,
                  font: {
                    size: "20",
                  },
                  color: "grey",
                },
              ],
            },
          },
          onClick: this.statusClicked,
          animation: false,
        },
        newStatusOptionsM: {
          responsive: true,
          maintainAspectRatio: true,
          aspectRatio: 1,
          tooltips: {
            callbacks: {
              label: (tooltipItem, data1) =>
                this.getTooltip(tooltipItem, data1),
            },
          },
          plugins: {
            datalabels: {
              display: true,
              backgroundColor: "transparent",
              borderRadius: 3,
              color: "#fff",
              font: {
                size: 12,
                weight: "bold",
              },
            },
            legend: {
              display: true,
              position: "left",
              // align:"start",
              animation: false,
              labels: {
                fontSize: 15,
              },
            },
            doughnutlabel: {
              labels: [
                {
                  text: "Total",
                  font: {
                    size: "12",
                  },
                  color: "grey",
                },
                {
                  text: getTotal,
                  font: {
                    size: "20",
                  },
                  color: "grey",
                },
              ],
            },
          },
          onClick: this.statusClicked,
          animation: false,
        },
      });
    }
    let list = document.querySelectorAll('div[role="dialog"]');
    list.forEach((l) => l.removeAttribute("tabindex"));
  }
  handleScroll = () => {
    let flag = false;
    let set = document.getElementsByClassName("scrollfix");
    Object.entries(set).map(([key, value]) => {
      if (
        Object.values(value.classList).some((item) => item === "hasDatepicker")
      ) {
        flag = true;
      }
    });

    if (flag) {
      this.setState({
        ...this.state,
        scrollCount: this.state.scrollCount + 1,
      });
    }
  };
  async componentDidMount() {
    this.props.setLoginStateParams("deeplink", false);
    await this.props.setCampaignProspectStateParams("mailzipCodes", []);
    window.addEventListener("scroll", this.handleScroll, true);
    this.props.setStateParams("previewToSelectplan", false);
    //ChartJs.Chart.register.apply(null, Object.values(ChartJs).filter((chartClass) => (chartClass.id)));
    window.sessionStorage.setItem("agentLoggedIn", true);
    let queryString = window.location.search.split("=");
    if (queryString.length > 1) {
      this.props.setLoginStateParams("temporaryKeyCloaktoken", queryString[1]);
      this.props.setLoginStateParams("agentLoggedIn", true);
      const response = await this.props.getKeyCloakToken();
      // console.log("response...1", response);
      if (response.status === "OK") {
        await this.props.setLoginStateParams("isAuthorized", true);
        window.sessionStorage.setItem("token", response.data.token ?? "");
        window.sessionStorage.setItem("firstName", `${response.data.firstName} ${response.data.lastName}`);
        window.sessionStorage.setItem(
          "keyCloakData",
          JSON.stringify(response.data)
        );
        this.props.setTokenTORedux(response.data.token);
        await this.props.setLoginStateParams(
          "agentEmailId",
          response.data.agentDetails?.agentEmail
        );
        const agencyResponse=await this.props.getAgencyId(
          response?.data?.agentId,
          window.sessionStorage.getItem("customerId")
        );
        if(agencyResponse?.status==="FAILURE"){
          // window.localStorage.setItem("agencyAPIFlag",true)
          this.setState({
            ...this.state,
            snackBarOpen: true,
            snackBarMsg: "Unauthorized user access is not allowed!",
            snackBarSeverty: "error",
            vertical: "top",
            agencyErrorFlag:true,
          });
          setTimeout(()=>window.location.href=`${this.props.subDomain}/auth-api/logout?redirectUrl=e-Enroll/login`,200)
          return;
        }
        let isAgentRole = false;
        let isSuperUser = false;
        let isAgencyAdmin = false;
        for (let i = 0; i < response.data.roles?.length; i++) {
          if (response.data.roles[i] === "AGENT") {
            isAgentRole = true;
          }
          if (
            response.data.roles[i] === "SUPER_USER" ||
            response.data.roles[i] === "AGENCY_ADMIN"
          ) {
            isSuperUser = true;
          }
          if (response.data.roles[i] === "AGENCY_ADMIN") {
            isAgencyAdmin = true;
          }
        }

        await this.props.setLoginStateParams(
          "agencyIDSelected",
          this.props.agencyID[0].value?.trim()
        );
        await this.props.setStateParams("isAgentRole", isAgentRole);
        await this.props.setStateParams("isSuperUser", isSuperUser);
        await this.props.setLoginStateParams("isAgencyAdmin", isAgencyAdmin);
        await this.props.setStateParams("roles", response.data.roles);
        window.sessionStorage.setItem("isAgentRole", isAgentRole);
        window.sessionStorage.setItem("isSuperUser", isSuperUser);
        window.sessionStorage.setItem("isAgencyAdmin", isAgencyAdmin);
        window.sessionStorage.setItem(
          "roles",
          JSON.stringify(response.data.roles)
        );
        window.sessionStorage.setItem(
          "agencyIDSelected",
          this.props.agencyID[0].value?.trim()
        );
        history.push("/e-Enroll/dashboard");
      } else if (
        response.status === "FORBIDDEN" 
        // ||
        // !response ||
        // !response?.status // commented as breaking expected behavior
      ) {
        await this.props.setLoginStateParams("isAuthorized", false);
      }
    } else {
      //on refresh of dashboard
      if (JSON.parse(window.sessionStorage?.getItem("isAgentRole"))) {
        await this.props.setStateParams(
          "isAgentRole",
          JSON.parse(window.sessionStorage?.getItem("isAgentRole"))
        );
      }
      if (JSON.parse(window.sessionStorage?.getItem("isSuperUser"))) {
        await this.props.setStateParams(
          "isSuperUser",
          JSON.parse(window.sessionStorage?.getItem("isSuperUser"))
        );
      }
      if (JSON.parse(window.sessionStorage?.getItem("isAgencyAdmin"))) {
        await this.props.setLoginStateParams(
          "isAgencyAdmin",
          JSON.parse(window.sessionStorage?.getItem("isAgencyAdmin"))
        );
      }
      if (JSON.parse(window.sessionStorage?.getItem("roles"))) {
        this.props.setStateParams(
          "roles",
          JSON.parse(window.sessionStorage?.getItem("roles"))
        );
      }
      await this.props.setLoginStateParams(
        "customerId",
        window.sessionStorage.getItem("customerId")
      );
      if (JSON.parse(window.sessionStorage.getItem("keyCloakData"))) {
        let keyCloakData = JSON.parse(
          window.sessionStorage.getItem("keyCloakData")
        );
        let { firstName, lastName, agentDetails, tokenExpiry, userId ,token} =
          keyCloakData;
        let data2 = {
          firstName: firstName ?? "",
          lastName: lastName ?? "",
          agentFullName: agentDetails?.agentName ?? "",
          agentPhone: agentDetails?.agentPhone ?? "",
          agentId: agentDetails?.agentId ?? "",
          idleTime: tokenExpiry ?? "",
          userId: userId ?? "",
          agentEmailId: agentDetails?.agentEmail ?? "",
          agentTaxId: agentDetails?.agentTaxId ?? "",
          token: token ?? "",
        };
        await this.props.setLoginStateValues(data2);

        await this.props.getAgencyId(
          agentDetails?.agentId,
          window.sessionStorage.getItem("customerId")
        );
        await this.props.setLoginStateParams(
          "agencyIDSelected",
          window.sessionStorage.getItem("agencyIDSelected")
        );
        await this.props.setLoginStateParams(
          "agentLoggedIn",
          window.sessionStorage.getItem("agentLoggedIn")
        );
      }
      // if (!JSON.parse(window.sessionStorage.getItem("keyCloakData"))) {
      // history.push("/e-Enroll/Login")
      //  }
    }
    window.sessionStorage.setItem(
      "agencyId",
      this.props.agencyID[0].value?.trim()
    );
    if (JSON.parse(window.sessionStorage.getItem("isSuperUser"))) {
      this.props.setStateParams(
        "isSuperUser",
        JSON.parse(window.sessionStorage.getItem("isSuperUser"))
      );
    }
    if (JSON.parse(window.sessionStorage.getItem("isAgencyAdmin"))) {
      this.props.setLoginStateParams(
        "isAgencyAdmin",
        JSON.parse(window.sessionStorage.getItem("isAgencyAdmin"))
      );
    }
    if (JSON.parse(window.sessionStorage?.getItem("roles"))) {
      this.props.setStateParams(
        "roles",
        JSON.parse(window.sessionStorage?.getItem("roles"))
      );
    }
    await this.props.setLoginStateParams("mbiDetails", {});
    this.props.setPageName("dashboard");
    this.props.setStateParams("uploadedFilesInPreEnroll", []);
    this.props.setStateParams("attachmentList", []);
    this.props.setStateParams("selectedVo", {});
    this.props.setStateParams("Submitted", false);
    this.props.setStateParams("guestbeneagentAppNum", null);
    this.props.setStateParams("appNum", null);
    this.props.setStateParams("count", null);
    this.props.setStateParams("pendingApplFlag", false);
    this.props.setStateParams("preEnrollInfo", {});
    this.props.setLoginStateParams("selectedPlan", "");
    this.props.setStateParams("selectedIndex", null);
    this.props.setCampaignProspectStateParams("dashboardEntry", true);
    this.props.setStateParams("selectedProduct", "");
    if (window.innerWidth <= 1240) {
      this.setState({
        sideBarState: false,
        showRightIcon: true,
      });
    } else {
      this.setState({
        sideBarState: true,
        showRightIcon: false,
      });
    }
    if (this.props.token === "" || this.props.token === undefined) {
      if (
        this.props.emailAddress === "" ||
        this.props.firstName === "" ||
        this.props.email === "" ||
        this.props.agentEmailId === undefined
      ) {
        if (window.sessionStorage.getItem("agentLogin") === "true") {
          let keyCloakData2 = JSON.parse(
            window.sessionStorage.getItem("keyCloakData")
          );
          const {token}=keyCloakData2;
          let data = {
            agentEmailId: window.sessionStorage.getItem("email"),
            firstName: window.sessionStorage.getItem("firstName"),
            agentFullName: window.sessionStorage.getItem("agentFullName"),
            agentId: window.sessionStorage.getItem("agentId"),
            agencyIDSelected: window.sessionStorage.getItem("agencyId"),
            guestLogin: false,
            agentLoggedIn:
              window.sessionStorage.getItem("agentLoggedIn") == "true"
                ? true
                : false,
            beneficiaryLogin:
              window.sessionStorage.getItem("beneficiaryLogin") == "true"
                ? true
                : false,
            userId: window.sessionStorage.getItem("userId"),
            token:token??"",

          };
          this.props.setLoginStateValues(data);
          // await this.props.setLoginStateParams(
          //   "agentEmailId",
          //   window.sessionStorage.getItem("email")
          // );
          // await this.props.setLoginStateParams(
          //   "firstName",
          //   window.sessionStorage.getItem("firstName")
          // );
          // await this.props.setLoginStateParams(
          //   "agentFullName",
          //   window.sessionStorage.getItem("agentFullName")
          // );
          // await this.props.setLoginStateParams("agentLoggedIn", true);
          // this.props.setLoginStateParams(
          //   "agentId",
          //   window.sessionStorage.getItem("agentId")
          // );
          await this.props.getAgencyId(
            window.sessionStorage.getItem("agentId"),
            window.sessionStorage.getItem("customerId")
          );
          // this.props.setLoginStateParams(
          //   "agencyIDSelected",
          //   window.sessionStorage.getItem("agencyId")
          // );
          this.props.setStateParams("guestLoggedIn", false);
          // this.props.setLoginStateParams("guestLogin", false);
          // this.props.setLoginStateParams(
          //   "agentLoggedIn",
          //   window.sessionStorage.getItem("agentLoggedIn") == "true"
          //     ? true
          //     : false
          // );
          // this.props.setLoginStateParams(
          //   "beneficiaryLogin",
          //   window.sessionStorage.getItem("beneficiaryLogin") == "true"
          //     ? true
          //     : false
          // );
          this.props.setStateParams(
            "isAgentRole",
            window.sessionStorage.getItem("isAgentRole") === "true"
              ? true
              : false
          );
          this.props.setStateParams(
            "isSuperUser",
            window.sessionStorage.getItem("isSuperUser") === "true"
              ? true
              : false
          );
        }
      }
      this.props.setStateParams("year", new Date().getFullYear().toString());
      if (this.props.token === "" || this.props.token === undefined) {
        await this.props.setTokenTORedux(
          window.sessionStorage.getItem("token")
        );
      }
      // let emailaddr=this.props?.isAgentRole?!this.props?.isSuperUser?this.props.agentEmailId:"":"";
      // await this.props.agentCategoryDashboard(
      //   {startDate:"",endDate:""},
      //   INITIAL_STATE.customerId,
      //   // this.props.agentEmailId
      //   // ""
      //   emailaddr
      // );
    }
    // if (this.props.customerId === VERDA_CONSTS.ID) {
    //   if (new Date().getFullYear().toString() > "2024") {
    //     await this.props.yearSelection({
    //       planYear: new Date().getFullYear().toString(),
    //     });
    //   } else {
    //     await this.props.yearSelection({ planYear: "2024" });
    //   }
    // }
    await this.props.yearSelection({
      planYear: new Date().getFullYear().toString(),
    });
    this.setState({
      // sideBarState: true,
      prospectState: false,
      campaignState: false,
      PerformanceByAgent: false,
      PerformanceByCampaign: false,
      dashboardState: false,
      searchappl: true,
      bulkUploadProspect: false,
      bulkUploadCampaign: false,
      //showRightIcon:false
    });

    this.props.campaignManagement(false);
    this.props.prospectManagement(false);
    this.props.calenderTabActive(false);
    this.props.setKeyPerformanceByAgent(false);
    this.props.setKeyPerformanceByCampaign(false);
    // await this.props.searchProspect({
    //   firstName: "",
    //   lastName: "",
    //   statusType: "",
    //   assignedTo: "",
    //   leadIdNbr: "",
    //   planCampaignId: "",
    // });
    {
      this.props?.isSuperUser === true &&
        (await this.props.keyPerformanceByAgent({
          startDate: "",
          endDate: "",
          agentList: [],
        }));
    }
    {
      this.props?.isSuperUser === true &&
        (await this.props.keyPerformanceByCampaign({
          startDate: "",
          endDate: "",
          campaignList: [],
        }));
    }
    // await this.props.getCampaignPerformanceExport({
    //   startDate: "",
    //   endDate: "",
    //   campaignList: [],
    // });
    let emailaddr2 =
      // this.props?.isAgentRole
      //   ? !this.props?.isSuperUser
      //     ?
      this.props.agentEmailId;
    //   : ""
    // : "";
    await this.props.agentCategoryDashboard(
      {
        applId: "",
        startDate: "",
        endDate: "",
        firstName: "",
        lastName: "",
        agentUserId: this.props?.isSuperUser ? "" : this?.props?.userId,
      },
      this.props?.customerId,
      // this.props.agentEmailId
      // ""
      emailaddr2,
      this.props?.agentId,
      this.props?.agencyIDSelected
    );
    {
      this.props?.isSuperUser === true &&
        (await this.props.RapidDisEnrollmentByMonth());
    }
    const { pieChartCategoryData } = this.state;
    this.setData(
      pieChartCategoryData,
      "applicationCategoryData",
      "categoryLabels",
      "categoryValues",
      "Category"
    );
    let emailaddr1 =
      // this.props?.isAgentRole
      //   ? !this.props?.isSuperUser
      //     ?
      this.props.agentEmailId;
    //   : ""
    // : "";
    await this.props.agentStatusDashboard(
      {
        applId: "",
        firstName: "",
        lastName: "",
        agentUserId: this.props?.isSuperUser ? "" : this?.props?.userId,
      },
      this.props?.customerId,
      // this.props.agentEmailId
      // ""
      emailaddr1,
      this.props?.agentId,
      this.props?.agencyIDSelected
    );

    this.setData(
      this.props.chartStatusData,
      "applicationStatusData",
      "statusLabels",
      "statusValues",
      "Status"
    );
    await this.props.getMembershipAgentList(this.props?.customerId);
    this.props.setStateParams("soa", {});
    this.props.setStateParams("prospectEnroll", false);
    this.props.setStateParams("prospectflag", false);
    //checking user session....
    if (
      !this.props.agentLogin &&
      !this.props.guestLogin &&
      !this.props.beneficiaryLogin
    ) {
      history.push("/e-Enroll/Login");
    }
  }
  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }
  handleChangeAgent = (event, name) => {
    let value = "";
    value = event.target ? event.target.value : event.value;
    this.setState((prevState) => ({
      ...prevState,
      [name]: value.toUpperCase(),
    }));
  };
  static getDerivedStateFromProps(nextProps, state) {
    if (typeof nextProps.searchData !== "string") {
      if (nextProps.searchData.length > 0) {
        let index = 0;
        return {
          index: index,
          openPopup: true,
          tableData: nextProps.searchData,
          selectedRowIndex: 0,
          rowsPerPage: 10,
        };
      }
    } else {
      return {
        tableData: [],
      };
    }
  }
  handleSnackbar = async (msg, severity) => {
    this.setState({
      ...this.state,
      snackBarOpen: true,
      snackBarMsg: msg,
      snackBarSeverty: severity,
      vertical: "top",
    });
  };
  toggle = async () => {
    let sideExpand = !this.state.sideBarState;
    let rgt = !this.state.showRightIcon;
    await this.setState({
      sideBarState: sideExpand,
      showRightIcon: rgt,
    });
  };
  setData = (pieData, appData, Label, Value, type) => {
    let labelArray = [];
    let valueArray = [];
    let dropOptions = [];
    if (type === "Category") {
      //loop to extract labels and values for chart from response(json)
      for (let i = 0; i < Object.keys(pieData).length; i++) {
        const label = Object.keys(pieData)[i];
        const value = Object.values(pieData)[i].length;
        labelArray.push(label);
        valueArray.push(value);
      }
    } else {
      for (let i = 0; i < Object.keys(pieData).length; i++) {
        const label = Object.values(pieData)[i][0].applStatus;
        const value = Object.values(pieData)[i].length;
        const tempLabel = {
          label: Object.values(pieData)[i][0].applStatus,
          value: Object.keys(pieData)[i],
        };
        labelArray.push(label);
        valueArray.push(value);
        dropOptions.push(tempLabel);
      }
      this.setState({
        dropDownOptions: dropOptions,
      });
    }
    this.setState({
      [appData]: {
        [Label]: labelArray,
        [Value]: valueArray,
      },
    });
  };
  statusClicked = (event, item, legend) => {
    if (item[0]) {
      // let name = "";
      let index = "";
      let index1 = item[0].index;
      let label = legend.data.labels[index1]; //label of statusClicked item
      let labels = this.state.M360Status.filter(
        (data1) => data1.value.toUpperCase() === label
      );
      //debugger;
      let labelArray = Object.keys(this.props.chartStatusData);
      let data = this.props.chartStatusData[labelArray[index1]];

      labels.forEach((label1) => {
        if (labelArray.indexOf(label1.label) != -1) {
          index = labelArray.indexOf(label1.label);
          // name = labelArray[index]; //sonar
        }
      });
      this.setState({
        label: label.toUpperCase(),
        index: index,
        openPopup: true,
        tableData: data || [],
        showTable: true,
        memberHeader: true,
      });
    }
  };
  categoryClicked = async (event, item, legend) => {
    let index1 = item[0]?.index;
    if (
      item[0] &&
      (legend?.data?.labels[index1] === "IN PROGRESS" ||
        legend?.data?.labels[index1] === "READY" ||
        legend?.data?.labels[index1] === "SUBMITTED")
    ) {
      let label = legend?.data?.labels[index1]; //label of statusClicked item
      let labelArray = Object.keys(this.props.chartCategoryData);
      let index = labelArray.indexOf(label); //index of statusClicked item
      let name = labelArray[index];
      await this.props.setStateParams("searchedApplication", []);
      setTimeout(() => {
        this.setState({
          label: label.toUpperCase(),
          index: index,
          openPopup: true,
          tableData: this.props.chartCategoryData[name], //storing the data to be displayed in table
          //tableData: [this.props.chartStatusData], //storing the data to be displayed in table
          displayStatusPieChart: false,
          showTable: true,
        });
      }, 1000);
    } else {
      this.setState({
        tableData: [],
        showTable: false,
      });
    }
  };
  prospectrowSelectFirst = async (index, selectedData, rowsPerPage, type) => {
    this.setState(() => ({
      ...this.state,
      // rowsPerPage: rowsPerPage,
      selectedRowIndex: index,
    }));
  };
  //dont remove selectedData parameter
  rowSelect = async (index, selectedData, rowsPerPage, type) => {
    await this.setState(() => ({
      rowsPerPage: rowsPerPage,
      selectedRowIndex: index,
    }));
    if (type === "ROWSELECT") {
      if (this.state.pdfclicked === false) {
        // this.props.setLoginStateParams("selectedPlan", "SDAGC20");
        this.props.setStateParams("isUpdated", true);

        // await this.props.yearSelection({ planYear: "2023" });
      }
      let response = await this.props.setEnrollRedirect(
        selectedData.applId,
        this.props.agentEmailId,
        this.props?.customerId
      );
      if (response?.status === "OK") {
        await this.props.setStateParams("appNum", selectedData?.applId);
        await this.props.setLoginStateParams(
          "productId",
          response?.data?.productId
        );
        await this.props.setLoginStateParams(
          "selectedPlanName",
          response?.data?.planName
        );
        if (response?.data?.proposedEffDate) {
          if (this.props.customerId === VERDA_CONSTS.ID) {
            if (
              new Date().getFullYear().toString() >
              response?.data?.proposedEffDate?.split("/")[2]
            ) {
              await this.props.yearSelection({
                planYear: new Date().getFullYear().toString(),
              });
            } else {
              await this.props.yearSelection({
                planYear: response?.data?.proposedEffDate?.split("/")[2],
              });
            }
          } else {
            await this.props.yearSelection({
              planYear: response?.data?.proposedEffDate?.split("/")[2],
            });
          }
        } else {
          if (this.props.customerId === VERDA_CONSTS.ID) {
            if (new Date().getFullYear().toString() > "2024") {
              await this.props.yearSelection({
                planYear: new Date().getFullYear().toString(),
              });
            } else {
              await this.props.yearSelection({ planYear: "2024" });
            }
          } else {
            await this.props.setStateParams(
              "year",
              new Date().getFullYear().toString()
            );
          }
        }
        await this.props.getZipCodes(response.data.permanentAddress?.zipCode);
        await this.props.planSelectionContinue(
          {
            productId: this.props.preEnrollInfo.productId,
            customerId: this.props?.customerId,
          },
          this.props?.customerId
        );
        const params =
          this.props?.ZipCodes?.length > 0 &&
          this.props?.ZipCodes?.filter(
            (zipcode1) =>
              zipcode1.countyName === response.data.permanentAddress?.county
          );
        let body = { customerId: this.props?.customerId };
        await this.props.getPlans(
          response.data.permanentAddress?.zipCode,
          response.data.permanentAddress?.countyCd,
          body.customerId,
          params[0]?.stateCode,
          this?.props?.year
        );
        let plnType = this.props.cardDetails.filter(
          (x) => x.productId === response.data.productId
        );
        await this.props.setStateParams("planType", plnType[0]?.planType);
        await this.props.setLoginStateParams(
          "selectedPlan",
          plnType[0]?.planId
        );
        let val =
          selectedData.applStatus === "P" ||
          selectedData.applStatus === "In Progress"
            ? false
            : true;
        this.props.setStateParams("formDisable", val);
        if (response.status === "OK") {
          this.setState({
            confpdfData: response.data,
          });
          if (this.state.pdfclicked) {
            this.pdfdownload();
          } else if (this.state.soapdfclicked) {
            this.openPDFDoc(response.data.soaDetails);
          } else if (
            this.state.preenrollpdfclicked ||
            this.state.cordinationpdfclicked
          ) {
            this.formpdfDownload();
          } else {
            await this.props.setStateParams("pendingApplFlag", true);
            await this.props.setStateParams("appNum", response.data?.appNumber);
            await this.props.setStateParams(
              "zip",
              response.data?.permanentAddress?.zipCode
            );
            await this.props.setStateParams(
              "county",
              response.data?.permanentAddress?.county
            );
            await this.props.setStateParams(
              "state",
              response.data?.permanentAddress?.state
            );
            await this.props.setStateParams("soa", response.data?.soaDetails);
            history.push("/e-Enroll/enrollOnline");
          }
        } else {
          this.setState({
            snackBarOpen: true,
            snackBarMsg: "Error occured while loading the data",
            snackBarSeverty: "error",
          });
        }
      } else {
        this.setState({
          snackBarOpen: true,
          snackBarMsg: "Error occured while loading the data",
          snackBarSeverty: "error",
          vertical: "top",
        });
      }
    }
    this.setState({
      ...this.state,
      pdfclicked: false,
      soapdfclicked: false,
      preenrollpdfclicked: false,
      cordinationpdfclicked: false,
    });
  };
  formpdfDownload = async () => {
    let attachmentType;
    let pdfname;
    if (this.state.preenrollpdfclicked === true) {
      attachmentType = "PEP";
      pdfname = "PRE-ENROLLMENTFORM.pdf";
    } else {
      attachmentType = "CC";
      pdfname = "COORDINATION OF CARE.pdf";
    }
    const Formpayload = {
      appNumber: this?.props?.count,
      customerId: this?.props?.customerId,
      attachmentType: attachmentType,
    };
    const response1 = await this?.props.downloadFormsPdf(Formpayload);
    if (response1.status === "OK") {
      const blob = "data:application/pdf;base64," + response1.data;
      saveAs(blob, pdfname);
    } else {
      this.setState({
        snackBarOpen: true,
        snackBarMsg: response1?.data?.message,
        snackBarSeverty: "error",
        vertical: "top",
      });
    }
  };
  openPDFDoc = async (soaresponse) => {
    let blob;
    if (
      [VERDA_CONSTS.ID, NEBRASKA_CONSTS.ID,ILS_CONSTS.ID].some(
        (id) => id === this?.props?.customerId
      )
    ) {
      const payload = {
        appNumber: this?.props?.count,
        customerId: this?.props?.customerId,
        attachmentType: "SOA",
      };
      const response = await this?.props.downloadFormsPdf(payload);
      if (response.status === "OK") {
        blob = "data:application/pdf;base64," + response.data;
        saveAs(blob, "Soa.pdf");
      }
    } else {
      blob = await pdf(
        <SoaDocument
          title="Prospect Management"
          pdfData={soaresponse}
          dashboard="charts"
          component="fullrelation"
          customerId={this.props?.customerId}
          authorizedrelations={this.props.authorizedrelations}
        />
      ).toBlob();
      saveAs(blob, "Soa.pdf");
    }
  };
  pdfhandler = async (value) => {
    if (value === "soa") {
      this.setState({
        soapdfclicked: true,
      });
      return;
    }
    if (value === "preenrollment") {
      this.setState({
        preenrollpdfclicked: true,
      });
      return;
    }
    if (value === "cordination") {
      this.setState({
        cordinationpdfclicked: true,
      });
    } else {
      this.setState({
        pdfclicked: true,
      });
    }
  };
  pdfdownload = async () => {
    let qs = this.state?.confpdfData;
    qs.qsns = this.props.qsns;
    let blob;
    if (
      [VERDA_CONSTS.ID,NEBRASKA_CONSTS.ID,ILS_CONSTS.ID].some((ids)=>ids===this.props.customerId)
    ) {
      const payload = {
        appNumber: this?.props.count,
        customerId: this?.props.customerId,
        attachmentType: "ENRL",
      };
      const response = await this.props.downloadFormsPdf(payload);
      if (response.status === "OK") {
        blob = "data:application/pdf;base64," + response.data;
        //const blob = await pdf(response.data).toBlob();
        saveAs(blob, "Confirmation.pdf");
      }
      return;
    } else {
      blob = await pdf(
        <ConfPdf
          pdfData={qs}
          selectedVo={this.props.selectedVo}
          authorizedrelations={this.props.authorizedrelations}
        />
      ).toBlob();
    }
    saveAs(blob, "Confirmation.pdf");
  };
  redirect = async (e) => {
    e.preventDefault();
    await this.props.setStateParams("appNum", "");
    await this.props.setStateParams("pendingApplFlag", false);
    this.props.setStateParams("prospectEnroll", false);
    this.props.setStateParams("SOAData", {});
    this.props.prospectManagement(false);
    this.props.campaignManagement(false);
    this.props.calenderTabActive(false);
    this.props.setKeyPerformanceByAgent(false);
    this.props.setKeyPerformanceByCampaign(false);
    await this.props.setStateParams("preEnrollInfo", {});
    this.props.setStateParams("isUpdated", false);
    await this.props.setStateParams("pendingApplFlag", false);
    this.props.setStateParams("soa", {});
    this.props.setCampaignProspectStateParams("bulkUploadEntry", false);
    this.props.setCampaignProspectStateParams("dashboardEntry", false);
    history.push("/e-Enroll/select-pin");
  };
  redirectToCalendar = () => {
    this.setState(() => ({
      eventCalState: true,
      searchUserState: false,
      prospectState: false,
      // sideBarState: false,
      campaignState: false,
      PerformanceByAgent: false,
      PerformanceByCampaign: false,
      dashboardState: false,
      searchappl: false,
      bulkUploadProspect: false,
      bulkUploadCampaign: false,
      // showRightIcon:false
    }));
    this.props.campaignManagement(false);
    this.props.prospectManagement(false);
    this.props.calenderTabActive(true);
    this.props.setKeyPerformanceByAgent(false);
    this.props.setKeyPerformanceByCampaign(false);
    this.props.setCampaignProspectStateParams("bulkUploadEntry", false);
    this.props.setCampaignProspectStateParams("dashboardEntry", false);
  };
  redirectToSearchUser = () => {
    this.setState(() => ({
      prospectState: false,
      searchUserState: true,
      campaignState: false,
      PerformanceByAgent: false,
      PerformanceByCampaign: false,
      dashboardState: false,
      searchappl: false,
      bulkUploadProspect: false,
      bulkUploadCampaign: false,
      eventCalState: false,
    }));
    this.props.campaignManagement(false);
    this.props.prospectManagement(false);
    this.props.calenderTabActive(false);
    this.props.setKeyPerformanceByAgent(false);
    this.props.setKeyPerformanceByCampaign(false);
    this.props.setCampaignProspectStateParams("bulkUploadEntry", false);
    this.props.setCampaignProspectStateParams("dashboardEntry", false);
  };
  redirectToProspect = async (e) => {
    this.setState(() => ({
      prospectState: true,
      // sideBarState: true,
      campaignState: false,
      PerformanceByAgent: false,
      PerformanceByCampaign: false,
      dashboardState: false,
      searchappl: false,
      bulkUploadProspect: false,
      bulkUploadCampaign: false,
      eventCalState: false,
      searchUserState: false,

      // showRightIcon:false
    }));
    this.props.campaignManagement(false);
    this.props.prospectManagement(true);
    this.props.calenderTabActive(false);
    this.props.setKeyPerformanceByAgent(false);
    this.props.setKeyPerformanceByCampaign(false);
    this.props.setCampaignProspectStateParams("bulkUploadEntry", false);
    this.props.setCampaignProspectStateParams("dashboardEntry", false);
    // e.preventDefault();
    // history.push("/e-Enroll/prospect-management");
  };

  redirectToBulkUpload = async (e) => {
    this.setState(() => ({
      prospectState: false,
      campaignState: false,
      PerformanceByAgent: false,
      PerformanceByCampaign: false,
      dashboardState: false,
      searchappl: false,
      bulkUploadProspect: true,
      bulkUploadCampaign: false,
      eventCalState: false,
      searchUserState: false,
    }));
    this.props.campaignManagement(false);
    this.props.prospectManagement(false);
    this.props.calenderTabActive(false);
    this.props.setKeyPerformanceByAgent(false);
    this.props.setKeyPerformanceByCampaign(false);
    this.props.setCampaignProspectStateParams("bulkUploadEntry", false);
    this.props.setCampaignProspectStateParams("dashboardEntry", false);
  };
  redirectToBulkUploadCampaign = async (e) => {
    this.setState(() => ({
      prospectState: false,
      campaignState: false,
      PerformanceByAgent: false,
      PerformanceByCampaign: false,
      dashboardState: false,
      searchappl: false,
      bulkUploadProspect: false,
      bulkUploadCampaign: true,
      eventCalState: false,
      searchUserState: false,
      bulkUploadCampaign: true,
    }));
    this.props.campaignManagement(false);
    this.props.prospectManagement(false);
    this.props.setKeyPerformanceByAgent(false);
    this.props.setKeyPerformanceByCampaign(false);
  };
  redirectToCampaign = async (e) => {
    await this.props.setStateParams("appNum", "");
    await this.props.setStateParams("pendingApplFlag", false);
    // this.setState(() => ());
    this.setState(() => ({
      campaignState: true,
      // sideBarState: true,
      prospectState: false,
      PerformanceByAgent: false,
      eventCalState: false,
      searchUserState: false,
      PerformanceByCampaign: false,
      dashboardState: false,
      searchappl: false,
      bulkUploadProspect: false,
      bulkUploadCampaign: false,
      // sideBarState: !this.state.sideBarState,
      // showRightIcon:!this.state.showRightIcon
      // showRightIcon:false
    }));
    this.props.campaignManagement(true);
    this.props.prospectManagement(false);
    this.props.calenderTabActive(false);
    this.props.setKeyPerformanceByAgent(false);
    this.props.setKeyPerformanceByCampaign(false);
    this.props.setCampaignProspectStateParams("bulkUploadEntry", false);
    this.props.setCampaignProspectStateParams("dashboardEntry", false);
    //  e.preventDefault();
    //history.push("/e-Enroll/Campaign");
  };
  handleChangeRowsPerPage = async (rowsPerPage) => {
    this.setState(() => ({
      rowsPerPage: rowsPerPage,
    }));
  };
  closePopup = async () => {
    await this.props.setStateParams("searchedApplication", []);
    this.setState({
      openPopup: false,
      tableData: [],
    });
  };
  setSideBar = (status1) => (e) => {
    e.preventDefault();
    this.setState({
      sideBarState: status1,
      prospectState: false,
      campaignState: false,
      PerformanceByAgent: false,
      PerformanceByCampaign: false,
      dashboardState: false,
      searchappl: true,
      bulkUploadProspect: false,
      bulkUploadCampaign: false,
    });
    this.props.campaignManagement(false);
    this.props.prospectManagement(false);
    this.props.setKeyPerformanceByAgent(false);
    this.props.calenderTabActive(false);
    this.props.setKeyPerformanceByCampaign(false);
  };
  setSideBar1 = (status1) => (e) => {
    e.preventDefault();
    this.setState({
      sideBarState: status1,
    });
  };
  getTooltip = (tooltipItem, data1) => {
    let index = tooltipItem.index;
    let label = data1.labels[index];
    let value = data1.datasets[0].data[index];
    if (label === "Cancelled") label = "Application is cancelled by plan";
    if (label === "Denied eligibillity")
      label = "Application has been deemed not eligible by plan";
    if (label === "Duplicate application")
      label =
        "A duplicate application exists and currently being reviewed by plan";
    if (label === "Eligibility review")
      label = "The application eligibility is being reviewed";
    if (label === "Incomplete")
      label =
        "Application has incomplete information that is being reviewed by the plan";
    if (label === "Being Submitted to CMS")
      label =
        "The application is currently being submitted to CMS for approval";
    if (label === "RFI") label = "RFI has been initiated by plan";
    return label + " : " + value + " ";
  };
  handleSearchflag = async (body) => {
    await this.setState({
      searchFlag: body,
    });
  };
  handleSearchCrite = async (Id, Name) => {
    await this.setState({
      enrlCampaignId: Id,
      planCampaignName: Name,
    });
  };
  handleSnackClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    this.setState({
      snackBarOpen: false,
    });
  };
  handleClick = (event) => {
    //setAnchorEl(event.currentTarget);
    if (this.state.anchorEl !== event.currentTarget) {
      this.setState({
        ...this.state,
        anchorEl: event.currentTarget,
        //prospectState: false,
        //campaignState: false,
        searchappl: false,
        //PerformanceByAgent:false,
        //PerformanceByCampaign:false,
      });
    }
  };
  handleClose1 = () => {
    this.setState({
      anchorEl: null,
    });
  };
  handleClose = async (e) => {
    if (e.target?.innerText === "Key performance by Agent") {
      await this.props.campaignManagement(false);
      await this.props.prospectManagement(false);
      await this.props.calenderTabActive(false);
      await this.props.setKeyPerformanceByAgent(true);
      await this.props.setKeyPerformanceByCampaign(false);
      await this.props.keyPerformanceByAgent({
        startDate: "",
        endDate: "",
      });
      await this.props.getAgentPerformanceExport({
        startDate: "",
        endDate: "",
      });
      this.setState({
        ...this.state,
        PerformanceByAgent: true,
        PerformanceByCampaign: false,
        dashboardState: true,
        prospectState: false,
        sideBarState: true,
        campaignState: false,
        anchorEl: null,
        bulkUploadProspect: false,
        bulkUploadCampaign: false,
      });
    }
    if (e.target?.innerText === "Key performance by Campaign") {
      await this.props.campaignManagement(false);
      await this.props.prospectManagement(false);
      await this.props.calenderTabActive(false);
      await this.props.setKeyPerformanceByAgent(false);
      await this.props.setKeyPerformanceByCampaign(true);
      await this.props.keyPerformanceByCampaign({
        startDate: "",
        endDate: "",
      });
      await this.props.getCampaignPerformanceExport({
        startDate: "",
        endDate: "",
      });
      this.setState({
        ...this.state,
        PerformanceByCampaign: true,
        PerformanceByAgent: false,
        dashboardState: true,
        prospectState: false,
        sideBarState: true,
        campaignState: false,
        anchorEl: null,
        bulkUploadProspect: false,
        bulkUploadCampaign: false,
      });
    } else {
      this.setState({
        ...this.state,
        anchorEl: null,
      });
    }
  };
  searchExistingHandler = async () => {
    await this.props.setStateParams("appNum", "");
    await this.props.setStateParams("pendingApplFlag", false);
    let emailaddr =
      //  this.props?.isAgentRole
      //   ? !this.props?.isSuperUser
      //     ?
      this.props.agentEmailId;
    //   : ""
    // : "";
    await this.props.agentCategoryDashboard(
      {
        applId: "",
        startDate: "",
        endDate: "",
        firstName: "",
        lastName: "",
        agentUserId: this.props?.isSuperUser ? "" : this?.props?.userId,
      },
      this.props?.customerId,
      // this.props.agentEmailId
      // ""
      emailaddr,
      this.props?.agentId,
      // this.state?.agentName,
      this.props?.agencyIDSelected
    );
    await this.props.agentStatusDashboard(
      {
        applId: "",
        firstName: "",
        lastName: "",
        agentUserId: this.props?.isSuperUser ? "" : this?.props?.userId,
      },
      this.props?.customerId,
      // this.props.agentEmailId
      // ""
      emailaddr,
      this.props?.agentId,
      this.props?.agencyIDSelected
    );
    {
      this.props?.isSuperUser === true &&
        (await this.props.keyPerformanceByAgent({
          startDate: "",
          endDate: "",
        }));
    }
    {
      this.props?.isSuperUser === true &&
        (await this.props.getAgentPerformanceExport({
          startDate: "",
          endDate: "",
        }));
    }

    {
      this.props?.isSuperUser === true &&
        (await this.props.keyPerformanceByCampaign({
          startDate: "",
          endDate: "",
        }));
    }
    {
      this.props?.isSuperUser === true &&
        (await this.props.getCampaignPerformanceExport({
          startDate: "",
          endDate: "",
        }));
    }
    this.setState({
      sideBarState: true,
      prospectState: false,
      campaignState: false,
      PerformanceByAgent: false,
      PerformanceByCampaign: false,
      dashboardState: false,
      searchappl: true,
      showRightIcon: false,
      bulkUploadProspect: false,
      bulkUploadCampaign: false,
      eventCalState: false,
      searchUserState: false,
    });
    this.props.campaignManagement(false);
    this.props.prospectManagement(false);
    this.props.calenderTabActive(false);
    this.props.setKeyPerformanceByAgent(false);
    this.props.setKeyPerformanceByCampaign(false);
    this.props.setCampaignProspectStateParams("bulkUploadEntry", false);
    this.props.setCampaignProspectStateParams("dashboardEntry", true);
  };
  expandHandler = () => {
    this.setState({ ...this.state, expand: !this.state.expand });
  };
  tableExpandHandler = () => {
    this.setState({ ...this.state, tableExpand: !this.state.tableExpand });
  };
  modalOpen = () => {
    this.setState({ showTable: true });
  };
  modalClose = () => {
    this.setState({
      showTable: false,
      index: 0,
      rowsPerPage: 10,
      selectedRowIndex: 0,
      memberHeader: false,
      expand: true,
      tableExpand: true,
    });
  };
  modalChartOpen = async () => {
    this.setState({ showChart: true, expand: true });
    //let list=await document.querySelectorAll('div[role="dialog"]');
    if (await document.querySelectorAll('[role="dialog"]')[3]) {
      await document
        .querySelectorAll('[role="dialog"]')[3]
        .removeAttribute("tabindex");
    }
  };
  modalStatusChartOpen = async () => {
    this.setState({ showStatusChart: true, expand: true });
    await document.querySelectorAll('div[role="dialog"]');
    if (await document.querySelectorAll('[role="dialog"]')[3]) {
      await document
        .querySelectorAll('[role="dialog"]')[3]
        .removeAttribute("tabindex");
    }
  };
  modalChartClose = async () => {
    // this.setState({ showChart: false, expand: false })
    let emailaddr =
      // this.props?.isAgentRole
      //   ? !this.props?.isSuperUser
      //     ?
      this.props.agentEmailId;
    //   : ""
    // : "";
    await this.props.agentCategoryDashboard(
      {
        applId: "",
        startDate: "",
        endDate: "",
        firstName: "",
        lastName: "",
        agentUserId: this.props?.isSuperUser ? "" : this?.props?.userId,
      },
      this.props?.customerId,
      // this.state.email
      // ""
      emailaddr,
      this.props?.agentId,
      this.props?.agencyIDSelected
    );
    this.setData(
      this.props.chartCategoryData,
      "applicationCategoryData",
      "categoryLabels",
      "categoryValues",
      "Category"
    );
    this.setState({
      startDateCov: "",
      endDateCov: "",
      showChart: false,
      expand: false,
      agentName: "",
      firstName: "",
      lastName: "",
      applId: "",
    });
  };
  modalStatusChartClose = async () => {
    this.setState({
      showStatusChart: false,
      expand: false,
      startDateCov: "",
      endDateCov: "",
      agentName: "",
      firstName: "",
      lastName: "",
      applId: "",
    });
    let emailaddr =
      // this.props?.isAgentRole
      //   ? !this.props?.isSuperUser
      //     ?
      this.props.agentEmailId;
    //   : ""
    // : "";
    await this.props.agentStatusDashboard(
      {
        applId: "",
        firstName: "",
        lastName: "",
        agentUserId: this.props?.isSuperUser ? "" : this?.props?.userId,
      },
      this.props?.customerId,
      // this.props.agentEmailId
      // ""
      emailaddr,
      this.props?.agentId,
      this.props?.agencyIDSelected
    );
    this.setData(
      this.props.chartStatusData,
      "applicationStatusData",
      "statusLabels",
      "statusValues",
      "Status"
    );
  };
  handleSearch = async (flag) => {
    if (flag === "KeyPerformanceByCampaign") {
      if (this.state.startDate !== "") {
        if (this.state.endDate === "") {
          this.setState({
            ...this.state,
            snackBarOpen: true,
            snackBarMsg: "End Date can't be empty.",
            snackBarSeverty: "error",
            vertical: "top",
          });
          return;
        }
      } else {
        if (this.state.endDate !== "") {
          if (this.state.startDate === "") {
            this.setState({
              ...this.state,
              snackBarOpen: true,
              snackBarMsg: "Start Date can't be empty.",
              snackBarSeverty: "error",
              vertical: "top",
            });
            return;
          }
        }
      }
      await this.props.keyPerformanceByCampaign({
        startDate: this.state.startDate,
        endDate: this.state.endDate,
        campaignList: this.state.campaignName,
      });
      await this.props.getCampaignPerformanceExport({
        startDate: this.state.startDate,
        endDate: this.state.endDate,
        campaignList: this.state.campaignName,
      });
      return;
    }
    if (flag === "rapidDisenrollmentbymonth") {
      if (this.state.startDateRapid !== "") {
        if (this.state.endDateRapid === "") {
          this.setState({
            ...this.state,
            snackBarOpen: true,
            snackBarMsg: "End Date can't be empty.",
            snackBarSeverty: "error",
            vertical: "top",
          });
          return;
        }
      } else {
        if (this.state.endDateRapid !== "") {
          if (this.state.startDateRapid === "") {
            this.setState({
              ...this.state,
              snackBarOpen: true,
              snackBarMsg: "Start Date can't be empty.",
              snackBarSeverty: "error",
              vertical: "top",
            });
            return;
          }
        }
      }
      await this.props.RapidDisEnrollmentByMonth({
        startDate: this.state.startDateRapid,
        endDate: this.state.endDateRapid,
      });
    }
  };
  handleReset = async (flag) => {
    if (flag === "KeyPerformanceByCampaign") {
      await this.props.keyPerformanceByCampaign({
        startDate: "",
        endDate: "",
        campaignList: [],
      });
      await this.props.getCampaignPerformanceExport({
        startDate: "",
        endDate: "",
        campaignList: [],
      });
      this.setState({
        ...this.state,
        startDate: "",
        endDate: "",
        campaignName: [],
      });
      return;
    }
    if (flag === "rapidDisenrollmentbymonth") {
      await this.props.RapidDisEnrollmentByMonth();
      this.setState({
        ...this.state,
        startDateRapid: "",
        endDateRapid: "",
      });
    }
  };
  handleResetClose = async () => {
    this.setState({
      expand: true,
      firstName: "",
      lastName: "",
      campaignName: [],
      startDate: "",
      endDate: "",
    });
    await this.props.keyPerformanceByCampaign({
      startDate: "",
      endDate: "",
      campaignList: [],
    });
    await this.props.getCampaignPerformanceExport({
      startDate: "",
      endDate: "",
      campaignList: [],
    });
  };
  handleStatusSearch = async () => {
    if (this.state.startDateCov !== "") {
      if (this.state.endDateCov === "") {
        this.setState({
          ...this.state,
          snackBarOpen: true,
          snackBarMsg: "End Date can't be empty.",
          snackBarSeverty: "error",
          vertical: "top",
        });
        return;
      }
    } else {
      if (this.state.endDateCov !== "") {
        if (this.state.startDateCov === "") {
          this.setState({
            ...this.state,
            snackBarOpen: true,
            snackBarMsg: "Start Date can't be empty.",
            snackBarSeverty: "error",
            vertical: "top",
          });
          return;
        }
      }
    }
    let agentEmailId = this.props.membershipAgentList.filter(
      (x) => x.value === this.state.agentName
    );
    let SelectedagentUserId = agentEmailId && agentEmailId[0]?.userId;
    //let SelectedagentUserId=""
    if (this.state.agentName === "") {
      agentEmailId = "";
    } else {
      agentEmailId = agentEmailId[0].emailId;
    }
    if (this.state.startDateCov === "" && this.state.endDateCov === "") {
      await this.props.agentStatusDashboard(
        {
          applId: this.state.applId,
          firstName: this.state.firstName,
          lastName: this.state.lastName,
          agentUserId: this.props?.isSuperUser
            ? SelectedagentUserId
              ? SelectedagentUserId
              : ""
            : this?.props?.userId,
        },
        this.props?.customerId,
        this.props.agentEmailId,
        // ""
        //agentEmailId,
        this.props?.agentId,
        //(this.props.isSuperUser===true && this.state?.agentName)?this.state?.agentName:this.props?.agentId,
        this.props?.agencyIDSelected
      );
    } else {
      await this.props.submittedChart(
        {
          applId: this.state.applId,
          startDate: this.state.startDateCov,
          endDate: this.state.endDateCov,
          firstName: this.state.firstName,
          lastName: this.state.lastName,
          agentUserId: this.props?.isSuperUser
            ? SelectedagentUserId
              ? SelectedagentUserId
              : ""
            : this?.props?.userId,
        },
        this.props?.customerId,
        this?.props?.agentEmailId,
        //(this.props.isSuperUser===true && this.state?.agentName)?this.state?.agentName:this.props?.agentId,
        this.props?.agentId,
        this.props?.agencyIDSelected
      );
    }
    this.setData(
      this.props.chartStatusData,
      "applicationStatusData",
      "statusLabels",
      "statusValues",
      "Status"
    );
  };
  handleStatusReset = async () => {
    // await this.props.submittedChart({startDate:"",endDate:""},INITIAL_STATE.customerId,this.props.agentEmailId)
    // let emailaddr = this.props?.isAgentRole
    //   ? !this.props?.isSuperUser
    //     ? this.props.agentEmailId
    //     : ""
    //   : "";
    await this.props.agentStatusDashboard(
      {
        applId: "",
        firstName: "",
        lastName: "",
        agentUserId: this.props?.isSuperUser ? "" : this?.props?.userId,
      },
      this.props?.customerId,
      this.props.agentEmailId,
      // ""
      //emailaddr,
      this.props?.agentId,
      this.props?.agencyIDSelected
    );
    this.setData(
      this.props.chartStatusData,
      "applicationStatusData",
      "statusLabels",
      "statusValues",
      "Status"
    );
    this.setState({
      startDateCov: "",
      endDateCov: "",
      agentName: "",
      firstName: "",
      lastName: "",
      applId: "",
    });
  };
  handleCategorySearch = async () => {
    if (this.state.startDateCov !== "") {
      if (this.state.endDateCov === "") {
        this.setState({
          ...this.state,
          snackBarOpen: true,
          snackBarMsg: "End Date can't be empty.",
          snackBarSeverty: "error",
          vertical: "top",
        });
        return;
      }
    } else {
      if (this.state.endDateCov !== "") {
        if (this.state.startDateCov === "") {
          this.setState({
            ...this.state,
            snackBarOpen: true,
            snackBarMsg: "Start Date can't be empty.",
            snackBarSeverty: "error",
            vertical: "top",
          });
          return;
        }
      }
    }
    // let agentEmailId = this.props.membershipAgentList.filter(
    //   (x) => x.value === this.state.agentName
    // );
    // if (this.state.agentName === "") {
    //   agentEmailId = "";
    // } else {
    //   agentEmailId = agentEmailId[0].emailId;
    // }
    let emailaddr =
      // this.props?.isAgentRole
      //   ? !this.props?.isSuperUser
      //     ?
      this.props.agentEmailId;
    //   : agentEmailId
    // : agentEmailId;
    let userId = this.props?.membershipAgentList.filter(
      (x) => x.value === this.state?.agentName
    )[0].userId;
    //this.props.isSuperUser===true
    await this.props.agentCategoryDashboard(
      {
        applId: this.state.applId,
        startDate: this.state.startDateCov,
        endDate: this.state.endDateCov,
        firstName: this.state.firstName,
        lastName: this.state.lastName,
        agentUserId: this.props?.isSuperUser
          ? userId
            ? userId
            : ""
          : this?.props?.userId,
      },
      this.props?.customerId,
      // this.state.email
      emailaddr,
      this.props?.agentId,
      //(this.props.isSuperUser===true && this.state?.agentName)?this.state?.agentName:this.props?.agentId,
      this.props?.agencyIDSelected,
      userId
    );
    this.setData(
      this.props.chartCategoryData,
      "applicationCategoryData",
      "categoryLabels",
      "categoryValues",
      "Category"
    );
  };
  handleCategoryReset = async () => {
    // await this.props.submittedChart({startDate:"",endDate:""},INITIAL_STATE.customerId,this.props.agentEmailId)
    let agentEmailId = "";
    let emailaddr =
      // this.props?.isAgentRole
      //   ? !this.props?.isSuperUser
      //     ?
      this.props.agentEmailId;
    //   : agentEmailId
    // : agentEmailId;
    await this.props.agentCategoryDashboard(
      {
        applId: "",
        startDate: "",
        endDate: "",
        firstName: "",
        lastName: "",
        agentUserId: this.props?.isSuperUser ? "" : this?.props?.userId,
      },
      this.props?.customerId,
      // this.state.email
      // ""
      emailaddr,
      this.props?.agentId,
      this.props?.agencyIDSelected,
      ""
    );
    this.setData(
      this.props.chartCategoryData,
      "applicationCategoryData",
      "categoryLabels",
      "categoryValues",
      "Category"
    );
    this.setState({
      startDateCov: "",
      endDateCov: "",
      agentName: "",
      firstName: "",
      lastName: "",
      applId: "",
    });
  };
  handleDate = async (event) => {
    let name = event.target.name;
    let value = event.target.value;
    DateUtil.getDatePicker("#" + name).datepicker("hide");
    value = handleDateChange(value);
    if (value === "") {
      this.setState({
        snackBarOpen: true,
        alertMsg: "Please enter date in the MM/DD/YYYY format",
        severity: "error",
      });
    }
    await this.setState({ ...this.state, [name]: value });
    // DateUtil.getDatePicker("#" + name).datepicker("show");
  };
  handleDates = (fieldId) => {
    DateUtil.getDatePicker("#" + fieldId).datepicker("show");
    DateUtil.getDatePicker("#" + fieldId).on("change", (e) => {
      this.setDates(fieldId, e.target.value);
    });
  };
  setDates = async (fieldId, value) => {
    await this.setState({ ...this.state, [fieldId]: value });
  };
  handleRapidReset = () => {
    this.setState({ ...this.state, startDate: "", endDate: "" });
  };
  updateKey = async () => {
    await this.props.getAgentPerformanceExport({
      startDate: "",
      endDate: "",
      agentList: [],
    });
    this.setState({
      allEmails: this.props?.membershipAgentList,
      //   this.state.agentSummaryKey < 1 && this.props.KeyPerformanceByAgent,
      // agentSummaryKey: this.state.agentSummaryKey + 1,
    });
  };
  agentModalClose = () => {
    this.setState({
      agentSummaryKey: 0,
    });
  };
  handleMultipleSelectionDropdown = (name) => async (data) => {
    let multipleValues = [];
    data.forEach((data1) => {
      multipleValues.push(data1.value);
    });

    if (
      this.state.campaignName.length === 0 &&
      multipleValues.indexOf("") !== -1
    ) {
      multipleValues.splice(multipleValues.indexOf(""), 1);
    } else if (
      this.state.campaignName.length > 0 &&
      multipleValues.indexOf("") !== -1
    ) {
      multipleValues = [];
    }

    await this.setState({ ...this.state, [name]: multipleValues });
  };

  // onMouseEnter = () =>{
  // document.getElementById("prospectMenu").classList.add("show")
  // let dropdown =  document.querySelector("#prospectMenu .dropdown-menu");
  // dropdown.classList.add("show");
  // dropdown.style="position: absolute; transform: translate3d(474px, 104px, 0px); top: 0px; left: 0px; will-change: transform;"
  // }
  // onMouseLeave=()=>{
  //   document.getElementById("prospectMenu").classList.remove("show")
  // let dropdown =  document.querySelector("#prospectMenu .dropdown-menu");
  // dropdown.classList.remove("show");
  // //dropdown.style=""
  // }
  render() {
    const {
      statusLabels,
      // statusValues
    } = this.state.applicationStatusData;
    const {
      categoryLabels,
      // categoryValues
    } = this.state.applicationCategoryData;
    const {
      newCategoryData,
      newCategoryOptions,
      newCategoryOptionsM,
      newStatusData,
      newStatusOptions,
      newStatusOptionsM,
    } = this.state;
    const {
      // label,
      openPopup,
      rowsPerPage,
      selectedRowIndex,
      tableData,
      //displayStatusPieChart,
      dropDownOptions,
      eventCalState,
      searchUserState,
    } = this.state;
    // const statusOptions = {
    //   responsive: true,
    //   maintainAspectRatio: true,
    //   tooltips: {
    //     callbacks: {
    //       label: (tooltipItem, data1) => this.getTooltip(tooltipItem, data1),
    //     },
    //   },
    //   plugins: {
    //     legend: {
    //       display: true,
    //       position: "left",
    //       // align:"start",
    //       animation: false,
    //       labels: {
    //         fontSize: 15,
    //       },
    //     },
    //   },
    //   onClick: this.statusClicked,
    //   animation: false,
    // };
    // const categoryOptions = {
    //   responsive: true,
    //   maintainAspectRatio: true,
    //   plugins: {
    //     legend: {
    //       display: true,
    //       position: "left",
    //       animation: false,
    //       // align:"start",

    //       labels: {
    //         fontSize: 15,
    //       },
    //     },
    //   },

    //   tooltips: {
    //     callbacks: {
    //       label: (tooltipItem, data1) => this.getTooltip(tooltipItem, data1),
    //     },
    //   },
    //   onClick: this.categoryClicked,
    //   animation: false,
    // };

    // const statusData = {
    //   labels: statusLabels,
    //   datasets: [
    //     {
    //       data: statusValues,
    //       backgroundColor: [
    //         "#6699ff",
    //         "#ff99ff",
    //         "#51b065",
    //         "#63b0a3",
    //         "#5a8f86",
    //         "#56609c",
    //         "#529651",
    //         "#a68465",
    //         "#996077",
    //         "#609099",
    //         "#fcba03",
    //         "#abeb0c",
    //       ],
    //       hoverBackgroundColor: [
    //         "#b9edc4",
    //         "#abede2",
    //         "#5a8f86",
    //         "#56609c",
    //         "#529651",
    //         "#a68465",
    //         "#996077",
    //         "#609099",
    //       ],
    //     },
    //   ],
    // };
    // const categoryData = {
    //   labels: categoryLabels,
    //   datasets: [
    //     {
    //       data: categoryValues,
    //       backgroundColor: [
    //         "#ff8080",
    //         "#66ff66",
    //         "#ffa31a",
    //         "red",
    //         "green",
    //         "#51b065",
    //         "#63b0a3",
    //         "#5a8f86",
    //         "#56609c",
    //         "#529651",
    //         "#a68465",
    //         "#996077",
    //         "#609099",
    //         "#fcba03",
    //         "#abeb0c",
    //       ],
    //       hoverBackgroundColor: [
    //         "#b9edc4",
    //         "#abede2",
    //         "#5a8f86",
    //         "#56609c",
    //         "#529651",
    //         "#a68465",
    //         "#996077",
    //         "#609099",
    //       ],
    //     },
    //   ],
    // };
    const { vertical, horizontal, snackBarSeverty, snackBarMsg ,agencyErrorFlag} = this.state;
    return (
      <>
        {this.props.isAuthorized ? (
          <div class="">
            <Snackbar
              open={this.state.snackBarOpen}
              autoHideDuration={6000}
              onClose={this.handleSnackClose}
              anchorOrigin={{ vertical, horizontal }}
              key={this.state.vertical + this.state.horizontal}
            >
              <Alert onClose={this.handleSnackClose} severity={snackBarSeverty}>
                {snackBarMsg}
              </Alert>
            </Snackbar>
            {!agencyErrorFlag && 
            (<>
            <DashboardServices
              // nav items are customized based on service ids in init API
              states={this.state}
              searchExistingHandler={this.searchExistingHandler}
              redirect={this.redirect}
              theme={this.props.theme}
              isSuperUser={this.props.isSuperUser}
              isAgencyAdmin={this.props.isAgencyAdmin}
              redirectToCampaign={this.redirectToCampaign}
              redirectToProspect={this.redirectToProspect}
              redirectToBulkUploadCampaign={this.redirectToBulkUploadCampaign}
              redirectToBulkUpload={this.redirectToBulkUpload}
              redirectToCalendar={this.redirectToCalendar}
              redirectToSearchUser={this.redirectToSearchUser}
            />

            <div class="dash-layout">
              {this.state.prospectState ||
              this.state.campaignState ||
              this.state.searchUserState ? (
                <SideBarDashboard
                  isAgentRole={this?.props?.isAgentRole}
                  agentId={this?.props?.agentId}
                  isSuperUser={this.props?.isSuperUser}
                  customerId={this?.props?.customerId}
                  agentFullName={this?.props?.agentFullName}
                  categoryLabels={categoryLabels}
                  statusLabels={dropDownOptions}
                  setSideBar={this.setSideBar1}
                  show={this.state.sideBarState}
                  searchUserState={this.state.searchUserState}
                  prospectStatusLabels={this.state.prospectStatusLabels}
                  handleSearchflag={this.handleSearchflag}
                  handleSearchCrite={this.handleSearchCrite}
                  searchappl={this.state.searchappl}
                  showRightIcon={this.state.showRightIcon}
                  toggle={this.toggle}
                  showChart={this.state.showChart}
                  campaignState={this.state.campaignState}
                  prospectState={this.state.prospectState}
                  setCurrentSearchData={(searchData) =>
                    (this.searchPanelData = {
                      ...this.searchPanelData,
                      ...searchData,
                    })
                  }
                />
              ) : null}
              {this.props.campaignStateEntry ||
              this.props.prospectStateEntry ||
              this.state.searchUserState ? (
                this.state.showRightIcon ? (
                  <a
                    // type="button"
                    // id="sidebarCollapse"
                    className="btn btn-sidebaricon-hide rounded-circle display-flex"
                    onClick={this.toggle}
                  >
                    <ChevronRightSharpIcon
                      className="toggle-icon-color"
                      onClick={this.toggle}
                    />
                    {/* <span class=" btn-toggle-text ml-2">Toggle Sidebar</span> */}
                  </a>
                ) : null
              ) : null}
              {this.state.campaignState ? (
                <div
                  class={
                    this.state.sideBarState
                      ? "container-campaign"
                      : "container-campaign tableshift"
                  }
                >
                  <CampaignMgmt
                    searchFlag={this.state.searchFlag}
                    handleSearchflag={this.handleSearchflag}
                    planCampaignName={this.state.planCampaignName}
                    enrlCampaignId={this.state.enrlCampaignId}
                    searchPanelData={this.searchPanelData}
                  />
                </div>
              ) : null}

              {this.state.prospectState ? (
                <div
                  class={
                    this.state.sideBarState
                      ? "container-campaign"
                      : "container-campaign tableshift"
                  }
                >
                  <Prospectdashboard searchPanelData={this.searchPanelData} />
                </div>
              ) : null}
              {this.state.bulkUploadProspect === true ||
              this.state.bulkUploadCampaign === true ? (
                <div
                  class={
                    // this.state.sideBarState
                    //   ? "container-bulk pl-5 pr-5"
                    "container-bulk pl-3 pr-3 pt-3 margin-bottom10em"
                  }
                >
                  <BulkUpload
                    bulkUploadProspect={this.state?.bulkUploadProspect}
                    bulkUploadCampaign={this.state?.bulkUploadCampaign}
                    handleSnackbar={this.handleSnackbar}
                  />
                </div>
              ) : null}
              {eventCalState ? (
                <div class={"container-fluid"}>
                  <Calendar handleSnackbar={this.handleSnackbar} />
                </div>
              ) : null}

              {this.state.searchUserState === true && (
                <div
                  class={
                    this.state.sideBarState
                      ? "container-campaign"
                      : "container-campaign tableshift"
                  }
                >
                  <UserManagement />
                </div>
              )}
              {!this.state.prospectState &&
                !this.state.campaignState &&
                !this.state.bulkUploadProspect &&
                !this.state.bulkUploadCampaign &&
                !eventCalState &&
                !searchUserState && (
                  <div class="container-fluid" id="applStatus">
                    {/* <div class="dashboard-heading"></div> */}

                    {/* <div class="display-flex charts"> */}
                    {/* <div class="container-fluid"> */}
                    <div class="row">
                      {!this.state.prospectState &&
                        !this.state.campaignState &&
                        !this.state.bulkUploadProspect &&
                        !this.state.bulkUploadCampaign &&
                        // !this.state.PerformanceByAgent &&
                        // !this.state.PerformanceByCampaign &&

                        categoryLabels.length > 0 &&
                        (this.props.isSuperUser || this.props.isAgentRole) && (
                          <div class="col-lg-4 col-md-12 col-sm-12">
                            <div class="canvas-container mb-3">
                              <h3 class="chart-heading">
                                Application Status Summary
                              </h3>
                              <a
                                class="icon-position"
                                onClick={this.modalChartOpen}
                              >
                                {/* <OpenWithSharpIcon/> */}
                                <i className="fas" aria-hidden="true">
                                  
                                </i>
                              </a>
                              {/* <button  type="button" class="icon-position icon-resize-full-alt" data-toggle="modal"  data-target="#myModal1">
                    <OpenWithSharpIcon/>
                    </button> */}
                              {/* <div class="pie-chart-submitted"> */}
                              {/* <div class="chart-container"> */}
                              <Chart
                                type="pie"
                                id="categorychart"
                                data={newCategoryData}
                                options={newCategoryOptions}
                              />
                              {/* </div> */}
                              {/* </div> */}
                              {/* <canvas id="ApplicationStatusSummary" 
                            class="canvas-dimension" 
                            aria-label="Application Status Summary" role="img"
                            width="408px"
                            height="204px"
                            ></canvas> */}
                            </div>
                          </div>
                        )}

                      {!this.state.prospectState &&
                        !this.state.campaignState &&
                        !this.state.bulkUploadProspect &&
                        !this.state.bulkUploadCampaign &&
                        // !this.state.PerformanceByAgent &&
                        // !this.state.PerformanceByCampaign &&

                        categoryLabels.length === 0 &&
                        (this.props.isSuperUser || this.props.isAgentRole) && (
                          <div class="col-lg-4 col-md-12 col-sm-12">
                            <div class="canvas-container no-data-container">
                              <h3 class="chart-heading">
                                <strong>Application Status Summary</strong>
                              </h3>

                              <div class="no-data-chart-container justify-content-center">
                                <strong>No Application Found!</strong>
                              </div>
                            </div>
                          </div>
                        )}
                      {/* <div class="display-flex charts"> */}
                      {!this.state.prospectState &&
                      !this.state.campaignState &&
                      !this.state.bulkUploadProspect &&
                      !this.state.bulkUploadCampaign &&
                      statusLabels.length > 0 &&
                      (this.props.isSuperUser || this.props.isAgentRole) ? (
                        <div class="col-lg-4 col-md-12 col-sm-12">
                          <div class="canvas-container mb-3">
                            <h3 class="chart-heading">
                              Membership Status Summary
                            </h3>
                            <a
                              class="icon-position"
                              onClick={() => this.modalStatusChartOpen()}
                            >
                              {/* <OpenWithSharpIcon /> */}
                              <i className="fas" aria-hidden="true">
                                
                              </i>
                            </a>
                            {/* <div class="pie-chart-submitted"> */}
                            {/* {displayStatusPieChart ? ( */}
                            {/* <div class="chart-container"> */}
                            <Chart
                              type="doughnut"
                              id="statuschart"
                              data={newStatusData}
                              options={newStatusOptions}
                            />
                            {/* </div> */}
                            {/* ) : (
                  ""
                )} */}
                            {/* </div> */}
                          </div>
                        </div>
                      ) : !this.state.prospectState &&
                        !this.state.campaignState &&
                        !this.state.bulkUploadProspect &&
                        !this.state.bulkUploadCampaign &&
                        statusLabels.length < 1 &&
                        (this.props.isSuperUser || this.props.isAgentRole) ? (
                        <div class="col-lg-4 col-md-12 col-sm-12">
                          <div class="canvas-container no-data-container">
                            <h3 class="chart-heading">
                              <strong>Membership Status Summary </strong>
                            </h3>
                            <div class="no-data-chart-container justify-content-center">
                              <strong>No Application Found!</strong>
                            </div>
                          </div>
                        </div>
                      ) : null}
                      {!this.state.prospectState &&
                        !this.state.campaignState &&
                        !this.state.bulkUploadProspect &&
                        !this.state.bulkUploadCampaign &&
                        this.props.isSuperUser && (
                          <div class="col-lg-4 col-md-12 col-sm-12">
                            <div class="canvas-container mb-3">
                              <h3 class="chart-heading header-font">
                                Key Performance By Agent Summary
                              </h3>
                              <a
                                onClick={this.updateKey}
                                class="icon-position"
                                data-toggle="modal"
                                data-target="#modal3"
                              >
                                {/* <OpenWithSharpIcon/> */}
                                <i className="fas" aria-hidden="true">
                                  
                                </i>
                              </a>
                              {/* <div class="pie-chart-submitted"> */}
                              {/* <div class="line-chart-container"> */}
                              <PerformanceByAgent
                                KeyPerformanceByAgent={
                                  this.props.KeyPerformanceByAgent
                                }
                                showExport={false}
                                isModal={false}
                              />
                              {/* </div> */}

                              {/* </div> */}
                            </div>
                          </div>
                        )}

                      {!this.state.prospectState &&
                        !this.state.campaignState &&
                        !this.state.bulkUploadProspect &&
                        !this.state.bulkUploadCampaign &&
                        this.props.isSuperUser &&
                        this.props.supportingServices?.some(
                          (c) => c === "ENRLSVC1"
                        ) && (
                          <div class="col-lg-4 col-md-12 col-sm-12">
                            <div class="canvas-container mb-3">
                              <h3 class="chart-heading">
                                Key Performance By Campaign Summary
                              </h3>
                              <a
                                class="icon-position"
                                data-toggle="modal"
                                data-target="#modal4"
                                onClick={() => {
                                  this.props.getCampaignPerformanceExport({
                                    startDate: "",
                                    endDate: "",
                                    campaignList: [],
                                  });
                                  this.setState({
                                    ...this.state,
                                    expand: true,
                                  });
                                }}
                              >
                                {/* <OpenWithSharpIcon/> */}
                                <i className="fas" aria-hidden="true">
                                  
                                </i>
                              </a>
                              {/* <div class="pie-chart-submitted"> */}
                              {/* <div className="line-chart-container"> */}
                              <PerformanceByCampaign
                                KeyPerformanceByCampaign={
                                  this.props.KeyPerformanceByCampaign
                                }
                                showExport={false}
                                showXaxis={false}
                                isModal={false}
                              />
                              {/* </div> */}

                              {/* </div> */}
                            </div>
                          </div>
                        )}
                      {!this.state.prospectState &&
                        !this.state.campaignState &&
                        !this.state.bulkUploadProspect &&
                        !this.state.bulkUploadCampaign &&
                        this.props.isSuperUser && (
                          <div class="col-lg-4 col-md-12 col-sm-12">
                            <div class="canvas-container mb-3 overflow-auto">
                              <h3 class="chart-heading">
                                Rapid Dis-enrollments by Month
                              </h3>
                              <a
                                class="icon-position"
                                data-toggle="modal"
                                data-target="#modal5"
                                onClick={() => {
                                  this.setState({
                                    ...this.state,
                                    expand: true,
                                  });
                                }}
                              >
                                {/* <OpenWithSharpIcon/> */}
                                <i className="fas" aria-hidden="true">
                                  
                                </i>
                              </a>
                              {/* <div class="pie-chart-submitted"> */}
                              {/* <div className="line-chart-container"> */}
                              <RapidDisEnrollment
                                rapidDisenrollmentbymonth={
                                  this.props.rapidDisenrollmentbymonth
                                }
                                showExport={false}
                                showXaxis={false}
                                isModal={false}
                              />
                              {/* </div> */}

                              {/* </div> */}
                            </div>
                          </div>
                        )}
                    </div>
                    {/* </div> */}
                    <Modal
                      show={this.state.showTable}
                      onHide={this.modalClose}
                      size={this.state.tableExpand ? "xl" : "lg"}
                      centered
                      scrollable={true}
                      className="dashboard-zindex"
                      backdrop="static"
                    >
                      <Modal.Header className="modal-header-background">
                        <Modal.Title
                          className={
                            !this.state.tableExpand
                              ? "header-position-rapid"
                              : "header-expand-position-rapid"
                          }
                        >
                          {!this.state.memberHeader
                            ? "Application Status Summary"
                            : "Membership Status Summary"}
                        </Modal.Title>
                        <a
                          class="mr-left-50"
                          // class="close"
                          onClick={this.tableExpandHandler}
                        >
                          {!this.state.tableExpand ? (
                            <OpenWithSharpIcon />
                          ) : (
                            <CompareArrowsIcon />
                          )}
                        </a>
                        <button
                          type="button"
                          class="close"
                          onClick={this.modalClose}
                        >
                          &times;
                        </button>
                      </Modal.Header>

                      <Modal.Body>
                        {openPopup ? (
                          <div className="modal-table-container">
                            {/* <i
                    className="close"
                    onClick={this.closePopup}
                  >
                    &times;
                  </i> */}
                            <DataTable
                              data={
                                this.state.label != "IN PROGRESS"
                                  ? this?.props?.customerId === VERDA_CONSTS.ID
                                    ? tableData.map((row) =>
                                        Object.assign(row, {
                                          DOWNLOADSOA: React.createElement(
                                            "a",
                                            {
                                              class: "fa fa-file-pdf-o ml-4",
                                              style: { color: "red" },
                                              id: "dashboardpdfSOA",
                                              onClick: this.pdfhandler.bind(
                                                this,
                                                "soa"
                                              ),
                                            }
                                          ),
                                          DOWNLOAD: React.createElement("a", {
                                            class: "fa fa-file-pdf-o ml-4",
                                            style: { color: "red" },
                                            id: "dashboardpdf",
                                            onClick: this.pdfhandler.bind(
                                              this,
                                              "application"
                                            ),
                                          }),
                                          PREENROLLMENTFORM:
                                            row.pepInd === "YES" &&
                                            React.createElement("a", {
                                              class: "fa fa-file-pdf-o ml-4",
                                              style: { color: "red" },
                                              id: "preenrollmentpdf",
                                              onClick: this.pdfhandler.bind(
                                                this,
                                                "preenrollment"
                                              ),
                                            }),
                                          COORDINATIONOFCARE:
                                            row.ccInd === "YES" &&
                                            React.createElement("a", {
                                              class: "fa fa-file-pdf-o ml-4",
                                              style: { color: "red" },
                                              id: "coordinationcarepdf",
                                              onClick: this.pdfhandler.bind(
                                                this,
                                                "cordination"
                                              ),
                                            }),
                                        })
                                      )
                                    : tableData.map((row) =>
                                        Object.assign(row, {
                                          DOWNLOADSOA: React.createElement(
                                            "a",
                                            {
                                              class: "fa fa-file-pdf-o ml-4",
                                              style: { color: "red" },
                                              id: "dashboardpdfSOA",
                                              onClick: this.pdfhandler.bind(
                                                this,
                                                "soa"
                                              ),
                                            }
                                          ),
                                          DOWNLOAD: React.createElement("a", {
                                            class: "fa fa-file-pdf-o ml-4",
                                            style: { color: "red" },
                                            id: "dashboardpdf",
                                            onClick: this.pdfhandler.bind(
                                              this,
                                              "application"
                                            ),
                                          }),
                                        })
                                      )
                                  : tableData
                              }
                              dashboard="search"
                              header={
                                !this.state.memberHeader
                                  ? this.state.label != "IN PROGRESS"
                                    ? this?.props?.customerId ===
                                      VERDA_CONSTS.ID
                                      ? verdapdfheader
                                      : pdfheader
                                    : header
                                  : this.state.label != "IN PROGRESS"
                                  ? this?.props?.customerId === VERDA_CONSTS.ID
                                    ? verdapdfheader1
                                    : pdfheader1
                                  : header1
                              }
                              status={this.state.label}
                              exportAsExcel={true}
                              rowsPerPage={rowsPerPage}
                              rowsPerPageOptions={[10, 15, 20]}
                              index={selectedRowIndex}
                              handleChangeRowsPerPage={
                                this.handleChangeRowsPerPage
                              }
                              sortable={true}
                              searchable={true}
                              //exportAsExcel={true}
                              clicked={this.rowSelect}
                              dateColumn="applReceivedDate,lastSaved"
                              setClick={(x) => {}}
                              doubleClick={true}
                              clickedFirst={this.prospectrowSelectFirst}
                              soapdfclicked={this.state.soapdfclicked}
                              pdfclicked={this.state.pdfclicked}
                              cordinationpdfclicked={
                                this.state.cordinationpdfclicked
                              }
                              preenrollpdfclicked={
                                this.state.preenrollpdfclicked
                              }
                            />
                          </div>
                        ) : (
                          ""
                        )}
                      </Modal.Body>

                      <Modal.Footer>
                        {/* <Button variant="secondary" onClick={this.modalClose}>
            Close
          </Button> */}
                      </Modal.Footer>
                    </Modal>
                    <div
                      class="modal"
                      role="dialog"
                      id="modal4"
                      data-backdrop="static"
                    >
                      <div
                        class={
                          this.state.expand
                            ? "modal-dialog modal-dialog-scrollable modal-xl"
                            : "modal-dialog modal-dialog-scrollable modal-lg"
                        }
                      >
                        <div class="modal-content">
                          <div class="modal-header modal-header-background">
                            <h4
                              class={
                                !this.state.expand
                                  ? "modal-title header-position-campaign"
                                  : "modal-title header-expand-position-campaign"
                              }
                            >
                              Key Performance By Campaign Summary
                            </h4>
                            {this.props.KeyPerformanceByCampaign?.labelList
                              ?.length > 0 ? (
                              <CSVLink
                                data={this.props.keyPerformanceByCampaignExport}
                                filename={"KeyPerformanceByCampaign.csv"}
                                className="btn btn-secondary4 pull-right icon-export mr-2"
                                headers={headerCampaign}
                              >
                                <i class="fa fa-share-square-o" /> Export
                              </CSVLink>
                            ) : null}
                            <a
                              class="pl-1 expand-icon-spacing"
                              // data-toggle="modal"
                              // data-target="#myModal1"
                              onClick={this.expandHandler}
                            >
                              {!this.state.expand ? (
                                <OpenWithSharpIcon />
                              ) : (
                                <CompareArrowsIcon />
                              )}
                            </a>
                            <button
                              type="button"
                              class="close"
                              data-dismiss="modal"
                              onClick={this.handleResetClose}
                            >
                              &times;
                            </button>
                          </div>

                          <div class="modal-body">
                            <div class="col-lg-12 col-md-12 col-sm-12">
                              <div
                                class="canvas-container mb-3 chartModal"
                                style={{
                                  height: !this.state.expand
                                    ? "390px"
                                    : "485px",
                                }}
                              >
                                {/* Removed overflow-auto calss from here added conditional height */}
                                <div
                                  className={
                                    this.state.expand
                                      ? "expanded-modal-line-chart-container"
                                      : "modal-line-chart-container"
                                  }
                                >
                                  <PerformanceByCampaign
                                    KeyPerformanceByCampaign={
                                      this.props.KeyPerformanceByCampaign
                                    }
                                    showExport={false}
                                    showXaxis={true}
                                    isModal={true}
                                  />
                                </div>

                                {/* </div> */}
                              </div>
                            </div>
                            <span class="row pad">
                              <div class="col-lg-3 col-md-4 col-sm-8">
                                <label for="campaignName" class="labelprospect">
                                  Campaign List:
                                </label>
                                <br />
                                <AutoComplete2
                                  handleChange={this.handleMultipleSelectionDropdown(
                                    "campaignName"
                                  )}
                                  //label="Campaign List"
                                  multiple={true}
                                  options={
                                    this.props.KeyPerformanceByCampaign?.list
                                      ? this.props.KeyPerformanceByCampaign
                                          ?.list
                                      : []
                                  }
                                  // disabled = "true"
                                  // defaultValue={defaultEmail}
                                  value={
                                    this.props.KeyPerformanceByCampaign?.list
                                      ? this.props.KeyPerformanceByCampaign?.list.filter(
                                          (data1) =>
                                            this.state.campaignName.indexOf(
                                              data1.value
                                            ) !== -1
                                        )
                                      : []
                                  }
                                  name="campaignName"
                                  margin="20px auto"
                                  width="100%"
                                  show={true}
                                />
                              </div>
                              <div className="mr-4"></div>
                              <div class="col-sm-3 col-md-4 col-lg-2">
                                <label for="startDate" class="labelprospect">
                                  Start Date:
                                </label>
                                <br />
                                <input
                                  type="text"
                                  class="form-control1"
                                  id="startDate"
                                  // readonly=""
                                  name="startDate"
                                  value={this.state.startDate}
                                  maxLength="10"
                                  onChange={this.handleDate}
                                  onClick={(e) => this.handleDates("startDate")}
                                  autoComplete="off"
                                  spellcheck="false"
                                  aria-autocomplete="both"
                                  aria-haspopup="false"
                                />
                              </div>
                              <div class="col-sm-3 col-md-4 col-lg-2">
                                <label for="endDate" class="labelprospect">
                                  End Date:
                                </label>
                                <br />
                                <input
                                  type="text"
                                  class="form-control1"
                                  maxLength="10"
                                  value={this.state.endDate}
                                  onChange={this.handleDate}
                                  onClick={(e) => this.handleDates("endDate")}
                                  name="endDate"
                                  id="endDate"
                                  // onChange={props.handleChange}
                                  autoComplete="off"
                                  spellcheck="false"
                                  aria-autocomplete="both"
                                  aria-haspopup="false"
                                />
                              </div>
                              <div className="mr-4"></div>
                              <div class="col-sm-6 col-md-8 col-lg-3">
                                <br />
                                <div class="d-flex flex-row">
                                  <button
                                    class="btn-primary-continue mr-2"
                                    onClick={() =>
                                      this.handleSearch(
                                        "KeyPerformanceByCampaign"
                                      )
                                    }
                                  >
                                    Search
                                  </button>

                                  <button
                                    class="btn-secondary-continue-dash"
                                    onClick={() =>
                                      this.handleReset(
                                        "KeyPerformanceByCampaign"
                                      )
                                    }
                                  >
                                    Reset
                                  </button>
                                </div>
                              </div>
                            </span>
                          </div>

                          <div class="modal-footer">
                            {/* <button type="button" class="btn btn-close btn-secondary btn-secondary4 btn-chart-close" data-dismiss="modal" onClick={this.handleReset}>Close</button> */}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      class="modal"
                      role="dialog"
                      id="modal5"
                      data-backdrop="static"
                    >
                      <div
                        class={
                          this.state.expand
                            ? "modal-dialog modal-dialog-scrollable modal-xl"
                            : "modal-dialog modal-dialog-scrollable modal-lg"
                        }
                      >
                        <div class="modal-content">
                          <div class="modal-header modal-header-background">
                            <h4
                              class={
                                !this.state.expand
                                  ? "modal-title header-position-rapid"
                                  : "modal-title header-expand-position-rapid"
                              }
                            >
                              {/* <h4 class="modal-title header-position"> */}
                              Rapid Dis-enrollments by Month
                            </h4>
                            <a class="close" onClick={this.expandHandler}>
                              {!this.state.expand ? (
                                <OpenWithSharpIcon />
                              ) : (
                                <CompareArrowsIcon />
                              )}
                            </a>
                            <button
                              type="button"
                              class="close"
                              data-dismiss="modal"
                              onClick={() => {
                                this.setState({
                                  expand: true,
                                  startDateRapid: "",
                                  endDateRapid: "",
                                });
                              }}
                            >
                              &times;
                            </button>
                          </div>

                          <div class="modal-body">
                            <div class="col-lg-12 col-md-12 col-sm-12">
                              <div
                                class="canvas-container mb-3 chartModal"
                                style={{
                                  height: !this.state.expand
                                    ? "390px"
                                    : "485px",
                                }}
                              >
                                <div
                                  className={
                                    this.state.expand
                                      ? "expanded-modal-line-chart-container"
                                      : "modal-line-chart-container overflow-auto"
                                  }
                                >
                                  <RapidDisEnrollment
                                    rapidDisenrollmentbymonth={
                                      this.props.rapidDisenrollmentbymonth
                                    }
                                    isModal={true}
                                    showExport={true}
                                    showXaxis={true}
                                  />
                                </div>

                                {/* </div> */}
                              </div>
                            </div>
                            <span class="row pad">
                              <div class="col-sm-3 col-md-4 col-lg-2">
                                <label
                                  for="startDateRapid"
                                  class="labelprospect"
                                >
                                  Start Date:
                                </label>
                                <br />
                                <input
                                  type="text"
                                  class="form-control1"
                                  id="startDateRapid"
                                  // readonly=""
                                  name="startDateRapid"
                                  value={this.state.startDateRapid}
                                  maxLength="10"
                                  onChange={this.handleDate}
                                  onClick={(e) =>
                                    this.handleDates("startDateRapid")
                                  }
                                  autoComplete="off"
                                  spellcheck="false"
                                  aria-autocomplete="both"
                                  aria-haspopup="false"
                                />
                              </div>
                              <div class="col-sm-3 col-md-4 col-lg-2">
                                <label for="endDate" class="labelprospect">
                                  End Date:
                                </label>
                                <br />
                                <input
                                  type="text"
                                  class="form-control1"
                                  maxLength="10"
                                  value={this.state.endDateRapid}
                                  onChange={this.handleDate}
                                  onClick={(e) =>
                                    this.handleDates("endDateRapid")
                                  }
                                  name="endDateRapid"
                                  id="endDateRapid"
                                  // onChange={props.handleChange}
                                  autoComplete="off"
                                  spellcheck="false"
                                  aria-autocomplete="both"
                                  aria-haspopup="false"
                                />
                              </div>
                              <div class="col-sm-6 col-md-8 col-lg-3">
                                <br />
                                <div class="d-flex flex-row">
                                  <button
                                    class="btn-primary-continue mr-2"
                                    onClick={() =>
                                      this.handleSearch(
                                        "rapidDisenrollmentbymonth"
                                      )
                                    }
                                  >
                                    Search
                                  </button>

                                  <button
                                    class="btn-secondary-continue-dash"
                                    onClick={() =>
                                      this.handleReset(
                                        "rapidDisenrollmentbymonth"
                                      )
                                    }
                                  >
                                    Reset
                                  </button>
                                </div>
                              </div>
                            </span>
                          </div>

                          <div class="modal-footer">
                            {/* <button type="button" class="btn btn-close btn-secondary btn-secondary4 btn-chart-close" data-dismiss="modal">Close</button> */}
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* <div class="footer-fixed-container">
          // <Footer1 />
          <FooterContainer/>
        </div> */}
                  </div>
                )}

              <Modal
                show={this.state.showChart}
                onHide={this.modalChartClose}
                size={this.state.expand ? "xl" : "lg"}
                centered
                scrollable={true}
                backdrop="static"
              >
                <Modal.Header className="modal-header-background">
                  <Modal.Title
                    className={
                      !this.state.expand
                        ? "header-position-rapid"
                        : "header-expand-position-rapid"
                    }
                  >
                    Application Status Summary
                  </Modal.Title>
                  <a
                    class="mr-left-50"
                    // class="close"
                    onClick={this.expandHandler}
                  >
                    {!this.state.expand ? (
                      <OpenWithSharpIcon />
                    ) : (
                      <CompareArrowsIcon />
                    )}
                  </a>
                  <button
                    type="button"
                    class="close"
                    onClick={this.modalChartClose}
                  >
                    &times;
                  </button>
                </Modal.Header>
                <Modal.Body>
                  {
                    !this.state.prospectState &&
                      !this.state.campaignState &&
                      !this.state.PerformanceByAgent &&
                      !this.state.PerformanceByCampaign &&
                      !this.state.bulkUploadProspect &&
                      !this.state.bulkUploadCampaign && (
                        //&&
                        //categoryLabels.length > 0
                        <div class="col-lg-12 col-md-12 col-sm-12">
                          {categoryLabels.length > 0 ? (
                            <div class="canvas-container mb-3 overflow-auto">
                              <div class="pie-chart-submitted">
                                <div
                                  class={
                                    this.state.expand
                                      ? "expanded-modal-chart-container"
                                      : "modal-chart-container"
                                  }
                                >
                                  <Chart
                                    type="pie"
                                    id="categotyChart"
                                    data={newCategoryData}
                                    options={newCategoryOptionsM}
                                  />
                                </div>
                              </div>
                            </div>
                          ) : (
                            <div class="canvas-container no-data-container">
                              <h3 class="chart-heading">
                                <strong>Application status summary </strong>
                              </h3>
                              <div class="no-data-chart-container justify-content-center">
                                <strong>No Application Found!</strong>
                              </div>
                            </div>
                          )}
                          <div class="row pad">
                            <div class="col-lg-3 col-md-4 col-sm-9">
                              <label for="applId" class="labelprospect">
                                Application ID:
                              </label>
                              <br />
                              <input
                                type="text"
                                class="form-control1"
                                value={this.state.applId}
                                name="applId"
                                id="applId"
                                onChange={(event) =>
                                  this.handleChangeAgent(event, "applId")
                                }
                                autoComplete="off"
                                spellcheck="false"
                                aria-autocomplete="both"
                                aria-haspopup="false"
                              />
                            </div>
                            {this.props.isSuperUser ? (
                              <>
                                <div className="col-lg-3 col-md-4 col-sm-9">
                                  <AutoComplete1
                                    handleChange={(event) =>
                                      this.handleChangeAgent(event, "agentName")
                                    }
                                    label="Agent List"
                                    options={this.props?.membershipAgentList}
                                    // disabled = "true"
                                    defaultValue={this.props?.membershipAgentList?.find(
                                      (data) =>
                                        data?.value === this.state.agentName
                                    )}
                                    value={this.props?.membershipAgentList?.find(
                                      (data) =>
                                        data?.value === this.state.agentName
                                    )}
                                    // name="Agent List"
                                    margin="24px auto"
                                    width="100%"
                                    fontSize="12px"
                                    show={true}
                                  />
                                </div>
                              </>
                            ) : null}
                            <div className="mr-4"></div>
                            <div class="col-sm-9 col-md-4 col-lg-2">
                              <label for="startDateCov" class="labelprospect">
                                Start Date:
                              </label>
                              <br />
                              <input
                                type="text"
                                class="form-control1"
                                id="startDateCov"
                                // readonly=""
                                name="startDateCov"
                                value={this.state.startDateCov}
                                maxLength="10"
                                onChange={this.handleDate}
                                onClick={(e) =>
                                  this.handleDates("startDateCov")
                                }
                                autoComplete="off"
                                spellcheck="false"
                                aria-autocomplete="both"
                                aria-haspopup="false"
                              />
                            </div>
                            <div class="col-sm-9 col-md-4 col-lg-2">
                              <label for="endDateCov" class="labelprospect">
                                End Date:
                              </label>
                              <br />
                              <input
                                type="text"
                                class="form-control1"
                                maxLength="10"
                                value={this.state.endDateCov}
                                onChange={this.handleDate}
                                onClick={(e) => this.handleDates("endDateCov")}
                                name="endDateCov"
                                id="endDateCov"
                                // onChange={props.handleChange}
                                autoComplete="off"
                                spellcheck="false"
                                aria-autocomplete="both"
                                aria-haspopup="false"
                              />
                            </div>
                            <div className="mr-4"></div>
                            <div class="col-sm-9 col-md-4 col-lg-3">
                              <label for="firstName" class="labelprospect">
                                First Name:
                              </label>
                              <br />
                              <input
                                type="text"
                                class="form-control1"
                                id="firstName"
                                name="firstName"
                                value={this.state.firstName}
                                onChange={(event) => {
                                  if (
                                    event.target.value !== "" &&
                                    !DataValidation.test(event.target.value)
                                  ) {
                                    return;
                                  }
                                  this.handleChangeAgent(event, "firstName");
                                }}
                                autoComplete="off"
                                spellcheck="false"
                                aria-autocomplete="both"
                                aria-haspopup="false"
                              />
                            </div>
                            <div class="col-sm-9 col-md-4 col-lg-3">
                              <label for="lastName" class="labelprospect">
                                Last Name:
                              </label>
                              <br />
                              <input
                                type="text"
                                class="form-control1"
                                value={this.state.lastName}
                                name="lastName"
                                id="lastName"
                                onChange={(event) => {
                                  if (
                                    event.target.value !== "" &&
                                    !DataValidation.test(event.target.value)
                                  ) {
                                    return;
                                  }
                                  this.handleChangeAgent(event, "lastName");
                                }}
                                autoComplete="off"
                                spellcheck="false"
                                aria-autocomplete="both"
                                aria-haspopup="false"
                              />
                            </div>
                            {/* {!this.props.isSuperUser &&  (
                          <div class="col-sm-6 col-md-6 col-lg-4 col-xl-3 paddingTop20 d-flex">
                            <button
                              class="btn-primary-continue mr-2"
                              onClick={this.handleCategorySearch}
                            >
                              Search
                            </button>
                           
                            <button
                              class="btn-secondary-continue-dash"
                              onClick={this.handleCategoryReset}
                            >
                              Reset
                            </button>
                          </div>
                        )} */}
                          </div>
                          {/* {this.props.isSuperUser && ( */}
                          <>
                            <div class="appStatusbutton mt-2">
                              <button
                                class="btn-primary-continue mr-2"
                                onClick={this.handleCategorySearch}
                              >
                                Search
                              </button>

                              <button
                                class="btn-secondary-continue-dash"
                                onClick={this.handleCategoryReset}
                              >
                                Reset
                              </button>
                            </div>
                            <br />
                            <br />
                          </>
                          {/* )} */}
                        </div>
                      )
                    // : (
                    //   <div class="col-lg-12 col-md-12 col-sm-12">

                    //     <div class="row pad overflow-auto">
                    //       {this.props.isSuperUser ? (
                    //         <div class="col-lg-3 col-md-4 col-sm-8">
                    //           <AutoComplete1
                    //             handleChange={this.handleChangeAgent("agentName")}
                    //             label="Agent List"
                    //             options={this.props?.membershipAgentList}
                    //             // disabled = "true"
                    //             defaultValue={this.props?.membershipAgentList?.find(
                    //               (data) => data?.value === this.state.agentName
                    //             )}
                    //             value={this.props?.membershipAgentList?.find(
                    //               (data) => data?.value === this.state.agentName
                    //             )}
                    //             // name="Agent List"
                    //             margin="20px auto"
                    //             width="100%"
                    //             show={true}
                    //           />
                    //         </div>
                    //       ) : null}
                    //       <div className="mr-4"></div>
                    //       <div class="col-sm-3 col-md-4 col-lg-2">
                    //         <label for="startDateCov" class="labelprospect">
                    //           Start Date4:
                    //         </label>
                    //         <br />
                    //         <input
                    //           type="text"
                    //           class="form-control1"
                    //           id="startDateCov"
                    //           // readonly=""
                    //           name="startDateCov"
                    //           value={this.state.startDateCov}
                    //           maxLength="10"
                    //           onChange={this.handleDate}
                    //           onClick={(e) => this.handleDates("startDateCov")}
                    //         />
                    //       </div>
                    //       <div class="col-sm-3 col-md-4 col-lg-2">
                    //         <label for="endDateCov" class="labelprospect">
                    //           End Date:
                    //         </label>
                    //         <br />
                    //         <input
                    //           type="text"
                    //           class="form-control1"
                    //           maxLength="10"
                    //           value={this.state.endDateCov}
                    //           onChange={this.handleDate}
                    //           onClick={(e) => this.handleDates("endDateCov")}
                    //           name="endDateCov"
                    //           id="endDateCov"
                    //           // onChange={props.handleChange}
                    //         />
                    //       </div>
                    //       <div className="mr-4"></div>
                    //       <div class="col-sm-3 col-md-4 col-lg-2">
                    //         <label for="firstName" class="labelprospect">
                    //           First Name:
                    //         </label>
                    //         <br />
                    //         <input
                    //           type="text"
                    //           class="form-control1"
                    //           id="firstName"
                    //           name="firstName"
                    //           value={this.state.firstName}
                    //           onChange={this.handleChangeAgent("firstName")}
                    //         />
                    //       </div>
                    //       <div class="col-sm-3 col-md-4 col-lg-2">
                    //         <label for="lastName" class="labelprospect">
                    //           Last Name:
                    //         </label>
                    //         <br />
                    //         <input
                    //           type="text"
                    //           class="form-control1"
                    //           value={this.state.lastName}
                    //           name="lastName"
                    //           id="lastName"
                    //           onChange={this.handleChangeAgent("lastName")}
                    //         />
                    //       </div>
                    //       <div class="col-sm-6 col-md-8 col-lg-3" />
                    //       <div class="col-sm-6 col-md-8 col-lg-3" />
                    //       <div class="col-sm-6 col-md-8 col-lg-3" />

                    //       <div class="col-sm-6 col-md-8 col-lg-3">
                    //         <br />
                    //         <div class="d-flex flex-row">
                    //           <button
                    //             class="btn-primary-continue mr-2"
                    //             onClick={this.handleCategorySearch}
                    //           >
                    //             Search
                    //           </button>
                    //           {/* </div>
                    //       <div class="col-sm-3 col-md-4 col-lg-1"> */}
                    //           {/* <br /> */}
                    //           <button
                    //             class="btn-secondary-continue-dash"
                    //             onClick={this.handleCategoryReset}
                    //           >
                    //             Reset
                    //           </button>
                    //         </div>
                    //       </div>
                    //     </div>
                    //   </div>
                    // )
                  }
                </Modal.Body>

                {/* <Modal.Footer> */}
                {/* <Button variant="secondary" onClick={this.modalChartClose}>
            Close
          </Button> */}
                {/* </Modal.Footer> */}
              </Modal>
              <Modal
                id="memberstatus"
                show={this.state.showStatusChart}
                onHide={this.modalStatusChartClose}
                size={this.state.expand ? "xl" : "lg"}
                centered
                scrollable={true}
                backdrop="static"
              >
                <Modal.Header className="modal-header-background">
                  <Modal.Title
                    className={
                      !this.state.expand
                        ? "header-position-rapid"
                        : "header-expand-position-rapid"
                    }
                  >
                    Membership Status Summary
                  </Modal.Title>
                  <a class="mr-left-50" onClick={this.expandHandler}>
                    {!this.state.expand ? (
                      <OpenWithSharpIcon />
                    ) : (
                      <CompareArrowsIcon />
                    )}
                  </a>
                  <button
                    type="button"
                    class="close"
                    onClick={this.modalStatusChartClose}
                  >
                    &times;
                  </button>
                </Modal.Header>
                <Modal.Body>
                  {
                    !this.state.prospectState &&
                      !this.state.campaignState &&
                      !this.state.PerformanceByAgent &&
                      !this.state.PerformanceByCampaign &&
                      !this.state.bulkUploadProspect &&
                      !this.state.bulkUploadCampaign && (
                        //statusLabels.length > 0 ?
                        <div class="col-lg-12 col-md-12 col-sm-12">
                          {statusLabels.length > 0 ? (
                            <div class="canvas-container mb-3 overflow-auto">
                              <div class="pie-chart-submitted">
                                <div
                                  class={
                                    this.state.expand
                                      ? "expanded-modal-chart-container"
                                      : "modal-chart-container"
                                  }
                                >
                                  <Chart
                                    type="doughnut"
                                    id="statusChart"
                                    data={newStatusData}
                                    options={newStatusOptionsM}
                                  />
                                </div>
                              </div>
                            </div>
                          ) : (
                            <div class="canvas-container no-data-container">
                              <h3 class="chart-heading">
                                <strong>Membership status summary </strong>
                              </h3>
                              <div class="no-data-chart-container justify-content-center">
                                <strong>No Application Found!</strong>
                              </div>
                            </div>
                          )}
                          <div class="row pad overflow-auto">
                            <div class="col-lg-3 col-md-4 col-sm-9">
                              <label for="applId" class="labelprospect">
                                Application ID:
                              </label>
                              <br />
                              <input
                                type="text"
                                class="form-control1"
                                value={this.state.applId}
                                name="applId"
                                id="applId"
                                onChange={(event) =>
                                  this.handleChangeAgent(event, "applId")
                                }
                                autoComplete="off"
                                spellcheck="false"
                                aria-autocomplete="both"
                                aria-haspopup="false"
                              />
                            </div>
                            {this.props.isSuperUser ? (
                              <>
                                <div className="col-lg-3 col-md-4 col-sm-9">
                                  <AutoComplete1
                                    handleChange={(event) =>
                                      this.handleChangeAgent(event, "agentName")
                                    }
                                    label="Agent List"
                                    options={this.props?.membershipAgentList}
                                    // disabled = "true"
                                    defaultValue={this.props?.membershipAgentList?.find(
                                      (data) =>
                                        data?.value === this.state.agentName
                                    )}
                                    value={this.props?.membershipAgentList?.find(
                                      (data) =>
                                        data?.value === this.state.agentName
                                    )}
                                    // name="Agent List"
                                    margin="20px auto"
                                    width="100%"
                                    show={true}
                                  />
                                </div>
                              </>
                            ) : null}
                            <div className="mr-4"></div>
                            <div class="col-sm-9 col-md-4 col-lg-2">
                              <label for="startDateCov" class="labelprospect">
                                Start Date:
                              </label>
                              <br />
                              <input
                                type="text"
                                class="form-control1"
                                id="startDateCov"
                                // readonly=""
                                name="startDateCov"
                                value={this.state.startDateCov}
                                maxLength="10"
                                onChange={this.handleDate}
                                onClick={(e) =>
                                  this.handleDates("startDateCov")
                                }
                                autoComplete="off"
                                spellcheck="false"
                                aria-autocomplete="both"
                                aria-haspopup="false"
                              />
                            </div>
                            <div class="col-sm-9 col-md-4 col-lg-2">
                              <label for="endDateCov" class="labelprospect">
                                End Date:
                              </label>
                              <br />
                              <input
                                type="text"
                                class="form-control1"
                                maxLength="10"
                                value={this.state.endDateCov}
                                onChange={this.handleDate}
                                onClick={(e) => this.handleDates("endDateCov")}
                                name="endDateCov"
                                id="endDateCov"
                                // onChange={props.handleChange}
                                autoComplete="off"
                                spellcheck="false"
                                aria-autocomplete="both"
                                aria-haspopup="false"
                              />
                            </div>
                            <div className="mr-4"></div>
                            <div class="col-sm-9 col-md-4 col-lg-3">
                              <label for="firstName" class="labelprospect">
                                First Name:
                              </label>
                              <br />
                              <input
                                type="text"
                                class="form-control1"
                                id="firstName"
                                name="firstName"
                                value={this.state.firstName}
                                onChange={(event) => {
                                  if (
                                    event.target.value !== "" &&
                                    !DataValidation.test(event.target.value)
                                  ) {
                                    return;
                                  }
                                  this.handleChangeAgent(event, "firstName");
                                }}
                                autoComplete="off"
                                spellcheck="false"
                                aria-autocomplete="both"
                                aria-haspopup="false"
                              />
                            </div>
                            <div class="col-sm-9 col-md-4 col-lg-3">
                              <label for="lastName" class="labelprospect">
                                Last Name:
                              </label>
                              <br />
                              <input
                                type="text"
                                class="form-control1"
                                value={this.state.lastName}
                                name="lastName"
                                id="lastName"
                                onChange={(event) => {
                                  if (
                                    event.target.value !== "" &&
                                    !DataValidation.test(event.target.value)
                                  ) {
                                    return;
                                  }
                                  this.handleChangeAgent(event, "lastName");
                                }}
                                autoComplete="off"
                                spellcheck="false"
                                aria-autocomplete="both"
                                aria-haspopup="false"
                              />
                            </div>
                            {/* {!this.props.isSuperUser &&  (
                          <div class="col-sm-6 col-md-6 col-lg-4 col-xl-3 mb-1 paddingTop20 d-flex">
                            <button
                              class="btn-primary-continue mr-2"
                              onClick={this.handleStatusSearch}
                            >
                              Search
                            </button>

                            <button
                              class="btn-secondary-continue-dash"
                              onClick={this.handleStatusReset}
                            >
                              Reset
                            </button>
                          </div>
                          

                        )} */}
                          </div>
                          {/* {this.props.isSuperUser && ( */}
                          <>
                            <div class="appStatusbutton mt-2">
                              <button
                                class="btn-primary-continue mr-2"
                                onClick={this.handleStatusSearch}
                              >
                                Search
                              </button>
                              {/* </div>
                    <div class="col-sm-3 col-md-4 col-lg-1"> */}
                              {/* <br /> */}
                              <button
                                class="btn-secondary-continue-dash"
                                onClick={this.handleStatusReset}
                              >
                                Reset
                              </button>
                            </div>
                            <br />
                            <br />
                          </>

                          <div></div>
                        </div>
                      )
                    // : (
                    //   //  {/* <ModalSearch
                    //   //   searchExisting={true}
                    //   //   categoryLabels={categoryLabels}
                    //   //   statusLabels={dropDownOptions}
                    //   //   /> */}
                    //   <div class="col-lg-12 col-md-12 col-sm-12">

                    //     <div class="row pad overflow-auto">
                    //       {this.props.isSuperUser ? (
                    //         <div class="col-lg-3 col-md-4 col-sm-8">
                    //           <AutoComplete1
                    //             handleChange={this.handleChangeAgent("agentName")}
                    //             label="Agent List"
                    //             options={this.props?.membershipAgentList}
                    //             // disabled = "true"
                    //             defaultValue={this.props?.membershipAgentList?.find(
                    //               (data) => data?.value === this.state.agentName
                    //             )}
                    //             value={this.props?.membershipAgentList?.find(
                    //               (data) => data?.value === this.state.agentName
                    //             )}
                    //             // name="Agent List"
                    //             margin="20px auto"
                    //             width="100%"
                    //             show={true}
                    //           />
                    //         </div>
                    //       ) : null}
                    //       <div className="mr-4"></div>
                    //       <div class="col-sm-3 col-md-4 col-lg-2">
                    //         <label for="startDateCov" class="labelprospect">
                    //           Start Date6:
                    //         </label>
                    //         <br />
                    //         <input
                    //           type="text"
                    //           class="form-control1"
                    //           id="startDateCov"
                    //           // readonly=""
                    //           name="startDateCov"
                    //           value={this.state.startDateCov}
                    //           maxLength="10"
                    //           onChange={this.handleDate}
                    //           onClick={(e) => this.handleDates("startDateCov")}
                    //         />
                    //       </div>
                    //       <div class="col-sm-3 col-md-4 col-lg-2">
                    //         <label for="endDateCov" class="labelprospect">
                    //           End Date:
                    //         </label>
                    //         <br />
                    //         <input
                    //           type="text"
                    //           class="form-control1"
                    //           maxLength="10"
                    //           value={this.state.endDateCov}
                    //           onChange={this.handleDate}
                    //           onClick={(e) => this.handleDates("endDateCov")}
                    //           name="endDateCov"
                    //           id="endDateCov"
                    //           // onChange={props.handleChange}
                    //         />
                    //       </div>
                    //       <div className="mr-4"></div>
                    //       <div class="col-sm-3 col-md-4 col-lg-2">
                    //         <label for="firstName" class="labelprospect">
                    //           First Name:
                    //         </label>
                    //         <br />
                    //         <input
                    //           type="text"
                    //           class="form-control1"
                    //           id="firstName"
                    //           name="firstName"
                    //           value={this.state.firstName}
                    //           onChange={this.handleChangeAgent("firstName")}
                    //         />
                    //       </div>
                    //       <div class="col-sm-3 col-md-4 col-lg-2">
                    //         <label for="lastName" class="labelprospect">
                    //           Last Name:
                    //         </label>
                    //         <br />
                    //         <input
                    //           type="text"
                    //           class="form-control1"
                    //           value={this.state.lastName}
                    //           name="lastName"
                    //           id="lastName"
                    //           onChange={this.handleChangeAgent("lastName")}
                    //         />
                    //       </div>
                    //       <div class="col-sm-6 col-md-8 col-lg-3" />
                    //       <div class="col-sm-6 col-md-8 col-lg-3" />
                    //       <div class="col-sm-6 col-md-8 col-lg-3" />
                    //       <div class="col-sm-6 col-md-8 col-lg-3">
                    //         <br />
                    //         <div class="d-flex flex-row">
                    //           <button
                    //             class="btn-primary-continue mr-2"
                    //             onClick={this.handleStatusSearch}
                    //           >
                    //             Search
                    //           </button>
                    //           {/* </div>
                    //       <div class="col-sm-3 col-md-4 col-lg-2">
                    //         <br /> */}
                    //           <button
                    //             class="btn-secondary-continue-dash"
                    //             onClick={this.handleStatusReset}
                    //           >
                    //             Reset
                    //           </button>
                    //         </div>
                    //       </div>
                    //     </div>
                    //   </div>
                    // )
                  }
                </Modal.Body>

                <Modal.Footer>
                  {/* <Button variant="secondary" onClick={this.modalStatusChartClose}>
            Close
          </Button> */}
                </Modal.Footer>
              </Modal>
              <AgentModal
                agentSummaryKey={this.state.agentSummaryKey}
                KeyPerformanceByAgent={this.props.KeyPerformanceByAgent}
                allEmails={this.state.allEmails}
                agentModalClose={this.agentModalClose}
                showExport={true}
              />
            </div>
            </>)
  }
          </div>
        ) : (
          <Unauthorized />
        )}
      </>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    year: state.webApp.year?.planYear
      ? state.webApp.year.planYear
      : state.webApp.year,
    qsns: state.webApp.qsns,
    chartCategoryData: state.webApp.dashboardCategoryData,
    chartStatusData: state.webApp.dashboardStatusData,
    emailId: state.login.emailAddress,
    searchData: state.webApp.searchedApplication,
    agentEmailId: state.login.agentEmailId,
    preEnrollInfo: state.webApp.preEnrollInfo,
    firstName: state.login.firstName,
    emailAddress: state.login.emailAddress,
    agentLogin: state.login.agentLoggedIn,
    guestLogin: state.login.guestLogin,
    beneficiaryLogin: state.login.beneficiaryLogin,
    email: state.login.agentEmailId,
    token: state.login.token,
    KeyPerformanceByAgent: state.webApp.PerformanceByAgent,
    KeyPerformanceByCampaign: state.webApp.KeyPerformanceByCampaign,
    prospectStateEntry: state.campaignProspect.prospectStateEntry,
    campaignStateEntry: state.campaignProspect.campaignStateEntry,
    keyPerformanceByCampaignExport: state.export.keyPerformanceByCampaignExport,
    rapidDisenrollmentbymonth: state.login.rapidDisenrollmentbymonth,
    isAgentRole: state.webApp.isAgentRole,
    isSuperUser: state.webApp.isSuperUser,
    isAgencyAdmin: state.login?.isAgencyAdmin,
    membershipAgentList: state.webApp.membershipAgentList,
    ZipCodes: state.webApp.zipCodes,
    cardDetails: state.webApp.planCardData,
    authorizedrelations: state.webApp.authorizedrelations,
    customerId: state.login.customerId,
    agencyIDSelected: state.login.agencyIDSelected,
    agencyID: state.login.agencyID,
    agentId: state.login.agentId,
    selectedVo: state.webApp.selectedVo,
    theme: state.login.theme,
    agentFullName: state.login.agentFullName,
    count: state.webApp.count ? state.webApp.count : state.webApp.appNum,
    keyCloakData: state.login.keyCloakData,
    userId: state.login.userId,
    isAuthorized: state.login.isAuthorized,
    supportingServices:
      state.login.customerSubdomainDetails?.supportingServices,
    subDomain: state.login.subDomain,
  };
};
const mapDispatchToProps = {
  RapidDisEnrollmentByMonth,
  agentStatusDashboard,
  setStateParams,
  setLoginStateParams,
  setEnrollRedirect,
  planSelectionContinue,
  yearSelection,
  prospectManagement,
  campaignManagement,
  searchProspect,
  agentCategoryDashboard,
  setTokenTORedux,
  keyPerformanceByAgent,
  setKeyPerformanceByAgent,
  keyPerformanceByCampaign,
  setKeyPerformanceByCampaign,
  getAgentPerformanceExport,
  getCampaignPerformanceExport,
  downloadFormsPdf,
  submittedChart,
  getMembershipAgentList,
  getZipCodes,
  getPlans,
  setPageName,
  calenderTabActive,
  getAgencyId,
  setLoginStateValues,
  setCampaignProspectStateParams,
  getKeyCloakToken,
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(Styles)(Dashboard));
